import axios from 'axios';

import { EndPoints } from './APIEndpoints';
import { GetFromLocalStorage, IsObjectEmpty, IsStringEmpty, AddInLocalStorage, Log, IsListEmpty, calcPercentage } from '../utilities/CommonMethods';
import {
    ParsedError, ParsedInstructoreDashboardReportResponse, parseFilteredPaginatedProgramsData, ParseSearchProgramsData, parsePaginatedProgramsData, ParsedNotificationList, ParsedEducationSummaryList, ParsedContinueLearningData, ParsedEnrolledPrograms, parsedProgram, parsedPreviousTopicFeedback, ParsedBatchmateDetails, ParsedGroupDetails,
    ParsedHomepageModulesData, ParsedModulesPageModulesList, ParsedTopicsList, ParsedModulesList, ParsedTopicDetails, ParsedQuizData, ParsedInstructorsList, ParsedUpcomingCertificates,
    ParsedInstructorDetails, ParsedQuizResult, ParsedBasicInfo, ParsedWorkExperienceList, ParsedAssignmentDetails, ParsedSubmissionsList, ParsedCertificationList,
    ParsedFeedbackDetails, ParsedFeedbackQuestions, ParsedAssignmentResult, ParsedOverallPerformanceData, ParsedOverallAttendanceData, ParsedCompleteCertificationData,
    ParsedOverallGradesData, ParsedJRSData, ParsedOverallSubmissionsData, ParsedModuleOverviewData, ParsedEnrolledModules, ParsedOngoingModuleData, ParsedCertificationSectionCertificateDetails,
    ParsedFeedbackData, ParsedSubmissionData, ParseNavigationTopicsList, ParseNavigationBatchCodeList, ParsePMNavigationTopicsList, ParsedPlannerData, ParsedAllModulesPageData, ParsedEvaluationCardsData,
    ParsedQuizSubmissionMetadata, ParsedQuizStudentSubmissionsList, ParseAssignmentStudentSubmissionData, ParsedAssignmentNewProblem, parsedQuizProblems,
    ParsedInstructorDailyTopicFeedbackReport, ParsedLiveSessionData, ParsedInstructorDailyFeedbackReportData, ParsedDailyFeedbackStudentsList,
    ParsedInstructorWeeklyFeedbackReportData, ParsedInstructorOverallReportData, ParsedInstructorAttendanceReportData, ParsedInstructorClassGradesReportData,
    ParsedInstructorStudentAttendanceReportData, ParsedStudentDailyFeedbackResponse, ParsedStudentWeeklyFeedbackResponse, ParsedStudentQuizSubmission, ParsedPMAllLearnersList, ParsedPMAllProgramsList, ParsedPMAllCertificationList, ParsedPMAllRoundList, ParsedPMAllInstructorsList, ParsedPMAllModulesList, ParsedUserAccountData,
    ParsedPMAllProgramsData, ParsedProgramsOverviewData, ParsedInstructorsData, ParsedCurriculumOverviewData, ParsedPMInstructorPerformanceData,
    ParsedModulePerformanceData, ParsedAllModulesDataForProgram, ParsedModuleTempalteList, ParsedLiveSessionScheduleData, ParsedProgramTemplateData, ParsedModuleTemplateData,
    ParsedPerformanceAttendanceByWeeks, ParsedPerformanceAttendanceByMonths, ParsedPerformanceClassGradesByWeeks, ParsedPerformanceClassGradesByMonths, ParsedEditProgramData, ParsedCertificationDetailsData, parseActiveCertificationData, parsedCertificationResources, parsedDashboardCertificationsData, ParsedCoursesAndCertifications, ParsedHonorsAndAccomplishments, ParsedJobsReportResponse, ParsedMissedSessionsResponse, ParsedBadgeData, ParsedMyRewardsData, ParsedInstructorPaymentReportResponse, ParsedEmailReportResponse, ParsedAttendanceDashboardReportResponse, ParsedModuleCostResponse, ParsedActiveFor30Days, ParsedEditRewardsData, ParsedAllJobs, ParsedCompanyData, ParsedStageHistoryOfAllJobs, ParsedJobDetails, ParsedBatchwiseCertificationData, ParsedBatchwiseActiveStudentData, ParsedBatchwiseCertificationPassStudentData, ParsedActiveStudentData, ParsedAllCertificationDetailsData, parsedAllDashboardCertificationsData, ParsedBatchwiseAttendance, ParsedInstructorDailyFeedbackReportDataOnPageLoad, ParsedInstructorDailyFeedbackReportDataOnPageLoadNew, ParsedInstructorDailyFeedbackReportDataOverall, ParsedInstructorDailyFeedbackReportDataOverallNew, ParsedInstructorDailyFeedbackReportPM, ParsedPMHomepageStats, ParsedPMHomepageOngoingModulesData, ParsedLearnerCertificationsListData, ParsedProgramDates,
    ParsedCoursesList,
    ParsedCourseDetails,
    ParsedWhatsappTemplate,
    ParsedWATemplatesList,
    ParsedEnrolledMDs,
    ParsedEnrolledMEs,
    ParsedEnrolledProgramsForTabs,
    ParsedTodaysPlanData,
    getParsedRecommendedCourses,
    ParsedMDCourseListingData
} from './DataParser';
import Constants from '../utilities/Constants';
import { APICodes } from './APICodes';
import defaultAvatar from '../assets/icons/default-avatar.png';
import SortHelper from '../utilities/SortHelper';
import { parseDate } from '../utilities/DateTimeUtils';
// import { parseDate } from '../utilities/DateTimeUtils';


const userPostLoginData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.HOME_PAGE_POST_LOGIN_DATA, {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('POST_LOGIN_DATA => ', response.data.user.placement_assistance);

        let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
        AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

        const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';

        const isLearner = response.data.user.user_category === 'student' ? true : false;
        const isProgramManager = response.data.user.user_category === 'admin' ? true : false;

        AddInLocalStorage(Constants.KEY_FULL_NAME, fullName);
        AddInLocalStorage(Constants.KEY_EMAIL, response.data.user.email);
        AddInLocalStorage(Constants.KEY_USERNAME, response.data.user.username);
        AddInLocalStorage(Constants.KEY_USER_ID, response.data.user.id);
        AddInLocalStorage(Constants.KEY_PHONE_NUMBER, response.data.user.phone_number);
        AddInLocalStorage(Constants.KEY_IS_LEARNER, isLearner);
        AddInLocalStorage(Constants.KEY_IS_PROGRAM_MANAGER, isProgramManager);
        AddInLocalStorage(Constants.KEY_LEARNER_BADGE, response.data.user.learner_status);
        AddInLocalStorage(Constants.KEY_CANDIDATE_SLUG, response.data.user.rcrm_slug);
        AddInLocalStorage(Constants.KEY_PLACEMENT_ASSISTANCE_SLUG, response.data.user.placement_assistance);

        const parsedObj = {
            userDetails: {
                profilePic: profilePic,
                username: response.data.user.username,
                userId: response.data.user.id,
                email: response.data.user.email,
                fullName: fullName,
                userCategory: response.data.user.user_category,
                isLearner: isLearner,
                isProgramManager: isProgramManager,
                unreadNotifCount: response.data.unread_notification_count,
                learnerBadge: response.data.user.learner_status,
                placementAssistance: response.data.user.placement_assistance,
            },
            continueLearningData: ParsedContinueLearningData(response.data),
            enrolledPrograms: ParsedEnrolledPrograms(response.data.enrolled_programs),
            ongoingProgram: parsedProgram(response.data.ongoing_program),
            previousTopicFeedback: parsedPreviousTopicFeedback(response.data.previous_topic_feedback)
        }
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_POST_LOGIN_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const userPostLoginDataInstructor = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.HOME_PAGE_POST_LOGIN_DATA_INSTRUCTOR, {
        // let response = await axios.get(EndPoints.HOME_PAGE_POST_LOGIN_DATA_INSTRUCTOR, {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        Log('POST_LOGIN_DATA_INSTRUCTOR => ', response.data);

        let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
        AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

        const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';
        AddInLocalStorage(Constants.KEY_FULL_NAME, fullName);
        AddInLocalStorage(Constants.KEY_EMAIL, response.data.user.email);
        AddInLocalStorage(Constants.KEY_USERNAME, response.data.user.username);
        AddInLocalStorage(Constants.KEY_USER_ID, response.data.user.id);
        AddInLocalStorage(Constants.KEY_IS_LEARNER, false);
        let parsedEnrolledModulesList = ParsedEnrolledModules(response.data.modules)
        const parsedObj = {
            userDetails: {
                profilePic: profilePic,
                username: response.data.user.username,
                userId: response.data.user.id,
                email: response.data.user.email,
                fullName: fullName,
                isLearner: false,
                unreadNotifCount: response.data.unread_notif_count
            },
            moduleOverviewData: ParsedModuleOverviewData(response.data),
            enrolledModules: SortHelper.sortEnrolledModulesByMostRecent(parsedEnrolledModulesList),
            ongoingModuleData: ParsedOngoingModuleData(response.data)
        }
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_POST_LOGIN_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const userPostLoginDataInstructorForModule = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.HOME_PAGE_POST_LOGIN_MODULE_DATA_INSTRUCTOR(batchCode, moduleName), {
        // let response = await axios.get(EndPoints.HOME_PAGE_POST_LOGIN_MODULE_DATA_INSTRUCTOR, {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('HOME_PAGE_POST_LOGIN_MODULE_DATA_INSTRUCTOR => ', response.data);

        let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
        AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

        const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';
        AddInLocalStorage(Constants.KEY_FULL_NAME, fullName);
        AddInLocalStorage(Constants.KEY_EMAIL, response.data.user.email);
        AddInLocalStorage(Constants.KEY_USERNAME, response.data.user.username);
        AddInLocalStorage(Constants.KEY_USER_ID, response.data.user.id);
        AddInLocalStorage(Constants.KEY_IS_LEARNER, false);

        const parsedObj = {
            userDetails: {
                profilePic: profilePic,
                username: response.data.user.username,
                userId: response.data.user.id,
                email: response.data.user.email,
                fullName: fullName,
                isLearner: false,
                unreadNotifCount: response.data.unread_notif_count
            },
            moduleOverviewData: ParsedModuleOverviewData(response.data),
            enrolledModules: ParsedEnrolledModules(response.data.modules),
            ongoingModuleData: ParsedOngoingModuleData(response.data)
        }
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_POST_LOGIN_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getLastSessionFeedbackData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_LAST_SESSION_FEEDBACK_DATA(batchCode, moduleName), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_LAST_SESSION_FEEDBACK_DATA => ', response.data);

        const parsedObj = {
            feedbackData: ParsedFeedbackData(response.data),
            submissionData: ParsedSubmissionData(response.data.assignment_quiz_data)
        }

        // console.log('Parsed data => ', parsedObj)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_POST_LOGIN_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getContinueLearningData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.HOME_PAGE_USER_PROGRAM_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('POST_LOGIN_CONTINUE_LEARNING_DATA => ', response.data.user.placement_assistance);
        let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
        AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

        const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';
        AddInLocalStorage(Constants.KEY_FULL_NAME, fullName);
        AddInLocalStorage(Constants.KEY_EMAIL, response.data.user.email);
        AddInLocalStorage(Constants.KEY_USERNAME, response.data.user.username);
        AddInLocalStorage(Constants.KEY_USER_ID, response.data.user.id);
        AddInLocalStorage(Constants.KEY_LEARNER_BADGE, response.data.user.learner_status);
        AddInLocalStorage(Constants.KEY_PLACEMENT_ASSISTANCE_SLUG, response.data.user.placement_assistance);

        const parsedObj = {
            userDetails: {
                profilePic: profilePic,
                username: response.data.user.username,
                userId: response.data.user.id,
                email: response.data.user.email,
                fullName: fullName,
                unreadNotifCount: response.data.unread_notification_count,
                learnerBadge: response.data.user.learner_status,
                placementAssistance: response.data.user.placement_assistance,
                badge: response.data.badge !== 'Gamification is not enable for this program' ? ParsedBadgeData(response.data) : {}
            },
            continueLearningData: ParsedContinueLearningData(response.data),
            enrolledPrograms: ParsedEnrolledPrograms(response.data.enrolled_programs),
            ongoingProgram: parsedProgram(response.data.ongoing_program),
            previousTopicFeedback: parsedPreviousTopicFeedback(response.data.previous_topic_feedback)
        }
        response.data = parsedObj;

        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_USER_PROGRAM_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getAutoEnrollUserLearningData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.HOME_PAGE_POST_LOGIN_LEARNER_DATA, {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('HOME_PAGE_POST_LOGIN_LEARNER_DATA => ', response.data);
        let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
        AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

        const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';
        AddInLocalStorage(Constants.KEY_FULL_NAME, fullName);
        AddInLocalStorage(Constants.KEY_EMAIL, response.data.user.email);
        AddInLocalStorage(Constants.KEY_USERNAME, response.data.user.username);
        AddInLocalStorage(Constants.KEY_USER_ID, response.data.user.id);
        AddInLocalStorage(Constants.KEY_LEARNER_BADGE, response.data.user.learner_status);
        AddInLocalStorage(Constants.KEY_PLACEMENT_ASSISTANCE_SLUG, response.data.user.placement_assistance);

        const parsedObj = {
            userDetails: {
                profilePic: profilePic,
                username: response.data.user.username,
                userId: response.data.user.id,
                email: response.data.user.email,
                fullName: fullName,
                unreadNotifCount: response.data.unread_notification_count,
                learnerBadge: response.data.user.learner_status,
                placementAssistance: response.data.user.placement_assistance,
                badge: !IsObjectEmpty(response.data.badge) && response.data.badge !== 'Gamification is not enable for this program' ? ParsedBadgeData(response.data) : {}
            },
            // continueLearningData: ParsedContinueLearningData(response.data),
            todaysPlan: ParsedTodaysPlanData(response.data.todays_plan),
            enrolledPrograms: ParsedEnrolledPrograms(response.data.enrolled_programs),
            enrolledProgramsDataForTabs: ParsedEnrolledProgramsForTabs(response.data.enrolled_programs),
            enrolledMicroDegrees: ParsedEnrolledMDs(response.data.enrolled_micro_degrees),
            enrolledMockExams: ParsedEnrolledMEs(response.data.enrolled_mock_exams),
            // ongoingProgram: parsedProgram(response.data.ongoing_program),
            previousTopicFeedback: parsedPreviousTopicFeedback(response.data.previous_topic_feedback)
        }
        response.data = parsedObj;

        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_USER_PROGRAM_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getUpcomingCompletedModulesData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.HOME_PAGE_PROGRAM_MODULES_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('POST_LOGIN_UPCOMING_MODULES_DATA => ', response.data);

        const parsedObj = {
            upcomingModulesData: ParsedHomepageModulesData(response.data.upcoming_modules, 'upcoming'),
            completedModuleData: ParsedHomepageModulesData(response.data.completed_modules, 'completed'),
        }
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.HOME_PAGE_PROGRAM_MODULES_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleDetails = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULES_PAGE_MODULES_LIST_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULES_LISTING_DATA RESPONSE => ', response.data);

        const parsedObj = {
            modulesList: ParsedModulesPageModulesList(response.data),
            currentTopic: ParsedTopicsList([response.data.topics_list.selected_topic]),
            currentTopicDetails: ParsedTopicDetails(response.data.topics_details),
            previousTopicFeedback: parsedPreviousTopicFeedback(response.data.previous_topic_feedback)
        }
        // console.log('Post Parsing Module List =>>>', parsedObj)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULES_PAGE_MODULES_LIST_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleTopicsList = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULES_PAGE_MODULE_TOPICS_LIST_DATA(batchCode, moduleName), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULE_TOPICS_LISTING_DATA RESPONSE => ', response.data);

        const parsedObj = {
            topicsList: ParsedTopicsList(response.data.topics_list.topics),
            currentTopic: ParsedTopicsList([response.data.topics_list.selected_topic]),
            currentTopicDetails: ParsedTopicDetails(response.data.topics_details),
            previousTopicFeedback: parsedPreviousTopicFeedback(response.data.previous_topic_feedback)
        }
        // console.log('Post Parsing Module List =>>>', parsedObj)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULES_PAGE_MODULE_TOPICS_LIST_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}


const getModuleTopicsDetails = async (batchCode, moduleName, topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULES_PAGE_TOPICS_DETAILS_DATA(batchCode, moduleName, topicId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULE_TOPICS_DETAILS_DATA RESPONSE => ', response.data);

        const parsedObj = {
            currentTopic: ParsedTopicsList([response.data.topics_details.topic]),
            currentTopicDetails: ParsedTopicDetails(response.data.topics_details),
            previousTopicFeedback: parsedPreviousTopicFeedback(response.data.previous_topic_feedback)
        }
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULES_PAGE_TOPICS_DETAILS_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleAssignmentTopicsDetails = async (assignmentId, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.ASSIGNMENT_PAGE_DATA(assignmentId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULE_ASSIGNMENT_TOPICS_DETAILS_DATA RESPONSE => ', response.data);

        const parsedObj = ParsedAssignmentDetails(response.data, moduleName)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.ASSIGNMENT_PAGE_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleQuizTopicsDetails = async (quizId, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_QUIZ_PAGE_DATA(quizId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_QUIZ_PAGE_DATA RESPONSE => ', response.data);

        const parsedObj = ParsedQuizData(response.data, moduleName);
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_QUIZ_PAGE_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleCompleteTopicDetails = async (batchCode, moduleName, topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULES_PAGE_FULL_TOPIC_DETAILS(batchCode, moduleName, topicId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULES_PAGE_FULL_TOPIC_DETAILS RESPONSE => ', response.data);

        const parsedObj = {
            modulesList: ParsedModulesPageModulesList(response.data),
            currentTopic: ParsedTopicsList([response.data.topics_list.selected_topic]),
            currentTopicDetails: ParsedTopicDetails(response.data.topics_details)
        }
        // console.log('Post Parsing Module List =>>>', parsedObj)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULES_PAGE_FULL_TOPIC_DETAILS, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleCompleteQuizDetails = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULES_PAGE_FULL_QUIZ_DETAILS(quizId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULES_PAGE_FULL_QUIZ_DETAILS RESPONSE => ', response.data);

        const parsedObj = {
            modulesList: ParsedModulesPageModulesList(response.data),
            quizData: ParsedQuizData(response.data)
        }
        // console.log('Post Parsing Module List =>>>', parsedObj)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULES_PAGE_FULL_QUIZ_DETAILS, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getModuleCompleteAssignmentDetails = async (assignmentId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULES_PAGE_FULL_ASSIGNMENT_DETAILS(assignmentId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('MODULES_PAGE_FULL_ASSIGNMENT_DETAILS RESPONSE => ', response.data);

        const parsedObj = {
            modulesList: ParsedModulesPageModulesList(response.data),
            assignmentData: ParsedAssignmentDetails(response.data)
        }
        // console.log('Post Parsing Module List =>>>', parsedObj)
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULES_PAGE_FULL_ASSIGNMENT_DETAILS, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getPublicProfileData = async (userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.get(EndPoints.PROFILE_PAGE_DATA, { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('PROFILE_PAGE_DATA Response => ', response);
            const userData = response.data.user_profile;

            const updatedData = {
                basicInfo: ParsedBasicInfo(userData),
                myInformation: {
                    title: !IsStringEmpty(userData.title) ? userData.title : 'None',
                    tagline: !IsStringEmpty(userData.tagline) ? userData.tagline : 'None',
                    about: !IsStringEmpty(userData.bio) ? userData.bio : 'None',
                    languages: !IsStringEmpty(userData.languages_known) ? userData.languages_known : ''
                },
                educationInfo: ParsedEducationSummaryList(userData),
                workExperienceList: ParsedWorkExperienceList(userData.work_details),
                learnerStatus: userData.learner_status,
                otherDetails: {
                    languages: !IsStringEmpty(userData.languages_known) ? userData.languages_known.split(',') : [],
                    skills: !IsListEmpty(userData.skills) ? userData.skills : [],
                    interests: !IsStringEmpty(userData.interests) ? userData.interests.split(',') : []
                },
                coursesAndCertifications: ParsedCoursesAndCertifications(userData.courses_and_certifications),
                honorsAndAccomplishments: ParsedHonorsAndAccomplishments(userData.honors_and_accomplishments)
            }
            response.data = updatedData;
            return response;
        })
        .catch(error => {
            // console.log('[Catch Error]  => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PROFILE_PAGE_DATA)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getPublicProfileDataNew = async (username) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';


    let response = await axios.get(EndPoints.PUBLIC_PROFILE_PAGE_DATA(username))
        .then(response => {
            // console.log('PUBLIC_PROFILE_PAGE_DATA Response => ', response);
            const userData = response.data.user_profile;

            const updatedData = {
                basicInfo: ParsedBasicInfo(userData),
                myInformation: {
                    title: !IsStringEmpty(userData.title) ? userData.title : 'None',
                    tagline: !IsStringEmpty(userData.tagline) ? userData.tagline : 'None',
                    about: !IsStringEmpty(userData.bio) ? userData.bio : 'None',
                    languages: !IsStringEmpty(userData.languages_known) ? userData.languages_known : ''
                },
                educationInfo: ParsedEducationSummaryList(userData),
                workExperienceList: ParsedWorkExperienceList(userData.work_details),
                learnerStatus: userData.learner_status,
                otherDetails: {
                    languages: !IsStringEmpty(userData.languages_known) ? userData.languages_known.split(',') : [],
                    skills: !IsListEmpty(userData.skills) ? userData.skills : [],
                    interests: !IsStringEmpty(userData.interests) ? userData.interests.split(',') : []
                },
                coursesAndCertifications: ParsedCoursesAndCertifications(userData.courses_and_certifications),
                honorsAndAccomplishments: ParsedHonorsAndAccomplishments(userData.honors_and_accomplishments)
            }
            response.data = updatedData;
            return response;
        })
        .catch(error => {
            // console.log('[Catch Error]  => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PUBLIC_PROFILE_PAGE_DATA(username))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getEditProfileData = async (userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.get(EndPoints.PROFILE_PAGE_DATA, { headers: { 'Authorization': token } })
        .then(res => {
            Log('PROFILE_PAGE_DATA Response => ', res);

            const updatedData = {
                basicInfo: ParsedBasicInfo(res.data.user_profile),
                myInformation: {
                    title: !IsStringEmpty(res.data.user_profile.title) ? res.data.user_profile.title : 'None',
                    tagline: !IsStringEmpty(res.data.user_profile.tagline) ? res.data.user_profile.tagline : 'None',
                    about: !IsStringEmpty(res.data.user_profile.bio) ? res.data.user_profile.bio : 'None',
                    languages: !IsStringEmpty(res.data.user_profile.languages_known) ? res.data.user_profile.languages_known : 'None',
                },
                educationInfo: ParsedEducationSummaryList(res.data.user_profile),
                workExperienceList: ParsedWorkExperienceList(res.data.user_profile.work_details),
                learnerStatus: res.data.user_profile.learner_status,
                otherDetails: {
                    languages: !IsStringEmpty(res.data.user_profile.languages_known) ? res.data.user_profile.languages_known.split(',') : [],
                    skills: !IsListEmpty(res.data.user_profile.skills) ? res.data.user_profile.skills : [],
                    interests: !IsStringEmpty(res.data.user_profile.interests) ? res.data.user_profile.interests.split(',') : []
                },
                coursesAndCertifications: ParsedCoursesAndCertifications(res.data.user_profile.courses_and_certifications),
                honorsAndAccomplishments: ParsedHonorsAndAccomplishments(res.data.user_profile.honors_and_accomplishments)
            }
            res.data = updatedData;
            return res;
        })
        .catch(error => {
            Log('GETTING ERROR FOR EDIT PROFILE DATA => ', error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PROFILE_PAGE_DATA, APICodes.EDIT_PROFILE_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const updateLearnerProfile = async (data, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.post(EndPoints.UPDATE_LEARNER_PROFILE, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('UPDATE_LEARNER_PROFILE Response', res);
            return res;
        })
        .catch(error => {
            // Log('UPDATE_LEARNER_PROFILE ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_LEARNER_PROFILE, APICodes.UPDATE_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const updateLearnerPlacementAssistanceStatus = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.UPDATE_LEARNER_PLACEMENT_ASSISTANCE_STATUS, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('UPDATE_LEARNER_PROFILE Response', res);
            return res;
        })
        .catch(error => {
            // Log('UPDATE_LEARNER_PROFILE ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_LEARNER_PLACEMENT_ASSISTANCE_STATUS, APICodes.UPDATE_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const createEducationSummaryItem = async (data, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.post(EndPoints.CREATE_EDUCATION_SUMMARY_ITEM, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('CREATE_EDUCATION_SUMMARY_ITEM Response', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_EDUCATION_SUMMARY_ITEM)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updateEducationSummaryItem = async (id, data, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.post(EndPoints.UPDATE_EDUCATION_SUMMARY_ITEM(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            //Log(res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_EDUCATION_SUMMARY_ITEM(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updatePinnedVideo = async (id) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.UPDATE_PINNED_VIDEO(id), { headers: { 'Authorization': token } })
        .then(res => {
            //Log(res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_PINNED_VIDEO(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const contactUs = async (data) => {
    let response = await axios.post(EndPoints.CONTACT_US, data)
        .then((res) => {
            //Log('SEND FEEDBACK Success:', res.data);
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, APICodes.SEND_FEEDBACK)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const getDropdownNotifications = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_DROPDOWN_NOTIFICATIONS, {
        headers: {
            'Authorization': token
        }
    }).then((res) => {
        //Log('Success: ', res);
        const updatedNotificationList = ParsedNotificationList(res.data.notifications);
        res.data.notifications = updatedNotificationList
        return res
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DROPDOWN_NOTIFICATIONS)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getFeedbackData = async (feedbackId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.FEEDBACK_POPUP_DATA(feedbackId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('Feedback Popup Data response => ', response.data);
            const parsedObj = {
                feedbackDetails: ParsedFeedbackDetails(response.data.feedback),
                feedbackQuestions: ParsedFeedbackQuestions(response.data.problems, response.data.feedback.type)
            }
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.FEEDBACK_POPUP_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}
const getNewFeedbackData = async (topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.NEW_FEEDBACK_POPUP_DATA(topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('Feedback Popup Data response => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.FEEDBACK_POPUP_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorsList = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.INSTRUCTORS_PAGE_INSTRUCTORS_LIST_DATA(batchCode), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('INSTRUCTORS_PAGE_INSTRUCTORS_LIST_DATA response => ', response.data);
            let parsedObj = {
                instructorsList: ParsedInstructorsList(response.data.instructors_list),
                instructorDetails: ParsedInstructorDetails(response.data.instructor_details.instructor_details,
                    response.data.instructor_details.total_hrs_taught,
                    response.data.instructor_details.total_students_taught,
                    response.data.instructor_details.overall_rating,
                    response.data.instructor_details.total_feedbacks_received),
                selectedInstructorId: !IsObjectEmpty(response.data.instructors_list) && !IsStringEmpty(response.data.instructors_list.selected_instructor) ? response.data.instructors_list.selected_instructor : ''
            }
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTORS_PAGE_INSTRUCTORS_LIST_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorDetails = async (instructorId, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.get(EndPoints.INSTRUCTORS_PAGE_INSTRUCTOR_DETAILS(instructorId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('INSTRUCTORS_PAGE_INSTRUCTOR_DETAILS response => ', response.data);

            const parsedInstructorData = ParsedInstructorDetails(response.data.instructor_details, response.data.total_hrs_taught, response.data.total_students_taught, response.data.overall_rating, response.data.total_feedbacks_received);
            response.data = parsedInstructorData;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTORS_PAGE_INSTRUCTOR_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const submitQuizResponses = async (quizId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.SUBMIT_QUIZ_RESPONSES(quizId), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('SUBMIT_QUIZ_RESPONSES Response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.SUBMIT_QUIZ_RESPONSES(quizId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getQuizResult = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_QUIZ_RESULT_DATA(quizId), { headers: { 'Authorization': token } })
        .then(res => {
            // Log('GET_QUIZ_RESULT_DATA Response => ', res);
            let updatedResponse = ParsedQuizResult(res.data);
            res.data = updatedResponse;
            return res;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_QUIZ_RESULT_DATA(quizId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const createWorkExperience = async (data, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.post(EndPoints.CREATE_WORK_EXPERIENCE, data, { headers: { 'Authorization': token } })
        .then(res => {
            //Log(res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_WORK_EXPERIENCE)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updateWorkExperience = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.UPDATE_WORK_EXPERIENCE(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            //Log(res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_WORK_EXPERIENCE(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const getAllLearnerSubmissions = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_SUBMISSIONS_PAGE_DATA(batchCode, 'all'), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_SUBMISSIONS_PAGE_DATA response => ', response.data);
            let parsedObj = ParsedSubmissionsList(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_SUBMISSIONS_PAGE_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const submitAssignmentProblem = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.SUBMIT_ASSIGNMENT_PROBLEM_DATA(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('assignment submission response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.SUBMIT_ASSIGNMENT_PROBLEM_DATA(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getAssignmentProblemResult = async (assignmentId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_ASSIGNMENT_PROBLEM_RESULT_DATA(assignmentId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_ASSIGNMENT_PROBLEM_RESULT_DATA response => ', response.data);
            let parsedObj = {
                problemsList: ParsedAssignmentResult(response.data),
                totalScore: !IsStringEmpty(response.data.total_points) ? response.data.total_points : 0,
                score: !IsStringEmpty(response.data.socre_achieved) ? response.data.socre_achieved : 0
            };
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_ASSIGNMENT_PROBLEM_RESULT_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const submitDailyFeedback = async (feedbackId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.SUBMIT_FEEDBACK_RESPONSES(feedbackId), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('Feedback submission response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.SUBMIT_FEEDBACK_RESPONSES(feedbackId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getOverallProgramPerformanceData = async (batchCode, moduleName, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.get(EndPoints.GET_OVERALL_PERFORMANCE_DATA(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_OVERALL_PERFORMANCE_DATA response => ', response.data);
            const parsedObj = ParsedOverallPerformanceData(response.data);

            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_OVERALL_PERFORMANCE_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getOverallProgramAttendanceData = async (batchCode, moduleName, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.get(EndPoints.GET_OVERALL_ATTENDANCE_DATA(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_OVERALL_ATTENDANCE_DATA response => ', response.data);
            const parsedObj = ParsedOverallAttendanceData(response.data);

            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_OVERALL_ATTENDANCE_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getOverallProgramGradesData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_OVERALL_GRADES_DATA(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_OVERALL_GRADES_DATA response => ', response.data);
            const parsedObj = ParsedOverallGradesData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_OVERALL_GRADES_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}
const getJRSData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_OVERALL_GRADES_DATA(batchCode), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_OVERALL_GRADES_DATA response => ', response.data);
            const parsedObj = ParsedJRSData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_OVERALL_GRADES_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const CalculateJRSData = async (batchCode, userName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CALCULATE_JRS_DATA(batchCode, userName), {}, { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CALCULATE_JRS_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const CalculateWholeJRSData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CALCULATE_WHOLE_JRS_DATA(batchCode), {}, { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CALCULATE_WHOLE_JRS_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getOverallProgramSubmissionsData = async (batchCode, moduleName, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }
    let response = await axios.get(EndPoints.GET_OVERALL_SUBMISSIONS_DATA(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_OVERALL_SUBMISSIONS_DATA response => ', response.data);
            const parsedObj = ParsedOverallSubmissionsData(response.data);

            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_OVERALL_SUBMISSIONS_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getCurriculumTopicsListData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CURRICULUM_TOPICS_LIST(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_CURRICULUM_TOPICS_LIST response => ', response.data);
            // const topicsList = ParsedTopicsList(response.data.topics);
            const parsedObj = (type) => {

                if (type === "assignment") {

                    return {
                        topicsList: ParseNavigationTopicsList(response.data.topics_list.topics),
                        currentTopic: ParsedTopicsList([response.data.assignment]),
                    }

                } else if (type === "quiz") {
                    return {
                        topicsList: ParseNavigationTopicsList(response.data.topics_list.topics),
                        currentTopic: ParsedTopicsList([response.data.quiz]),
                    }

                } else {
                    return {
                        topicsList: ParseNavigationTopicsList(response.data.topics_list.topics),
                        currentTopic: ParsedTopicsList([response.data.topics_list.selected_topic]),
                        currentTopicDetails: ParsedTopicDetails(response.data.topics_details)
                    }
                }
            }


            response.data = parsedObj(response.data.type);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CURRICULUM_TOPICS_LIST)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}
const getInstructorProgramListData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTOR_PROGRAM_LIST(), { headers: { 'Authorization': token } })
        .then(response => {
            const parsedObj = {
                batchCodeList: ParseNavigationBatchCodeList(response.data.batch_code_list),
                modules: ParsedModulesList(response.data.modules),
            }
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_INSTRUCTOR_PROGRAM_LIST)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getPMCurriculumTopicsListData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CURRICULUM_TOPICS_LIST(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_CURRICULUM_TOPICS_LIST response => ', response.data);
            // const topicsList = ParsedTopicsList(response.data.topics);
            const parsedObj = {
                topicsList: ParsePMNavigationTopicsList(response.data.topics_list.topics),
                currentTopic: ParsedTopicsList([response.data.topics_list.selected_topic]),
                currentTopicDetails: ParsedTopicDetails(response.data.topics_details)
            }
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CURRICULUM_TOPICS_LIST)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getCurriculumTopicDetails = async (topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CURRICULUM_TOPIC_DETAILS(topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_CURRICULUM_TOPIC_DETAILS response => ', response.data);
            const parsedObj = {
                currentTopic: ParsedTopicsList([response.data.topics_details.topic]),
                currentTopicDetails: ParsedTopicDetails(response.data.topics_details)
            }
            response.data = parsedObj;

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CURRICULUM_TOPIC_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}


const getCurriculumQuizDetails = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CURRICULUM_QUIZ_DETAILS(quizId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_CURRICULUM_QUIZ_DETAILS response => ', response.data);

            let updatedResponse = ParsedQuizResult(response.data, true);
            response.data = updatedResponse;

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CURRICULUM_QUIZ_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}


const getCurriculumAssignmentDetails = async (assignmentId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CURRICULUM_ASSIGNMENT_DETAILS(assignmentId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_CURRICULUM_ASSIGNMENT_DETAILS response => ', response.data);
            const parsedObj = ParsedAssignmentDetails(response.data)
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CURRICULUM_ASSIGNMENT_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const editQuizDetails = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_EDIT_QUIZ_DETAILS(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_EDIT_QUIZ_DETAILS response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_EDIT_QUIZ_DETAILS(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const addNewQuizQuestion = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_ADD_NEW_QUIZ_QUESTION(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_ADD_NEW_QUIZ_QUESTION response => ', res.data);
            const parsedQuizProblem = parsedQuizProblems([res.data.problem]);
            res.data = parsedQuizProblem;
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_ADD_NEW_QUIZ_QUESTION(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updateQuizQuestion = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_EDIT_QUIZ_QUESTION(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_EDIT_QUIZ_QUESTION response => ', res);
            const parsedQuizProblem = parsedQuizProblems([res.data.problem]);
            res.data = parsedQuizProblem;
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_EDIT_QUIZ_QUESTION(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const editAssignmentDetails = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_EDIT_ASSIGNMENT_DETAILS(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_EDIT_ASSIGNMENT_DETAILS response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_EDIT_ASSIGNMENT_DETAILS(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const addNewAssignmentProblem = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_ADD_NEW_ASSIGNMENT_PROBLEM(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_ADD_NEW_ASSIGNMENT_PROBLEM response => ', res.data);
            const newProblemData = ParsedAssignmentNewProblem(res.data.problem);
            res.data = newProblemData;
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_ADD_NEW_ASSIGNMENT_PROBLEM(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updateAssignmentProblem = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_EDIT_ASSIGNMENT_PROBLEM(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_EDIT_ASSIGNMENT_PROBLEM response => ', res);
            const newProblemData = ParsedAssignmentNewProblem(res.data.problem);
            res.data = newProblemData;
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_EDIT_ASSIGNMENT_PROBLEM(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getModulePlannerData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_MODULE_PLANNER_DATA(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_MODULE_PLANNER_DATA response => ', response.data);
            const parsedObj = ParsedPlannerData(response.data)
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_MODULE_PLANNER_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getCurriculumCompleteQuizDetails = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CURRICULUM_PAGE_FULL_QUIZ_DETAILS(quizId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('CURRICULUM_PAGE_FULL_QUIZ_DETAILS response => ', response.data);

            const parsedObj = {
                topicsList: ParsedTopicsList(response.data.topics_list.topics),
                quizData: ParsedQuizResult(response.data, true)
            }
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CURRICULUM_PAGE_FULL_QUIZ_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getCurriculumCompleteAssignmentDetails = async (assignmentId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CURRICULUM_PAGE_FULL_ASSIGNMENT_DETAILS(assignmentId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('CURRICULUM_PAGE_FULL_ASSIGNMENT_DETAILS response => ', response.data);

            const parsedObj = {
                topicsList: ParsedTopicsList(response.data.topics_list.topics),
                assignmentData: ParsedAssignmentDetails(response.data)
            }

            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CURRICULUM_PAGE_FULL_ASSIGNMENT_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getCurriculumCompleteTopicDetails = async (batchCode, moduleName, topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CURRICULUM_PAGE_FULL_TOPIC_DETAILS(batchCode, moduleName, topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('CURRICULUM_PAGE_FULL_TOPIC_DETAILS response => ', response.data);

            const parsedObj = {
                topicsList: ParseNavigationTopicsList(response.data.topics_list.topics),
                currentTopic: ParsedTopicsList([response.data.topics_details.topic]),
                currentTopicDetails: ParsedTopicDetails(response.data.topics_details)

            }
            response.data = parsedObj;

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CURRICULUM_PAGE_FULL_TOPIC_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getPMCurriculumCompleteTopicDetails = async (batchCode, moduleName, topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CURRICULUM_PAGE_FULL_TOPIC_DETAILS(batchCode, moduleName, topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('CURRICULUM_PAGE_FULL_TOPIC_DETAILS response => ', response.data);

            const parsedObj = {
                topicsList: ParsePMNavigationTopicsList(response.data.topics_list.topics),
                currentTopic: ParsedTopicsList([response.data.topics_details.topic]),
                currentTopicDetails: ParsedTopicDetails(response.data.topics_details)

            }
            response.data = parsedObj;

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CURRICULUM_PAGE_FULL_TOPIC_DETAILS)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}


const createNewAssignment = async (batchCode, moduleName, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_CREATE_NEW_ASSIGNMENT(batchCode, moduleName), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_CREATE_NEW_ASSIGNMENT response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_CREATE_NEW_ASSIGNMENT(batchCode, moduleName))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const createNewQuiz = async (batchCode, moduleName, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_CREATE_NEW_QUIZ(batchCode, moduleName), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_CREATE_NEW_QUIZ response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_CREATE_NEW_QUIZ(batchCode, moduleName))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const createNewTopic = async (batchCode, moduleName, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INSTRUCTOR_CREATE_NEW_TOPIC(batchCode, moduleName), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('INSTRUCTOR_CREATE_NEW_TOPIC response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_CREATE_NEW_TOPIC(batchCode, moduleName))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getInstructorAllModulesList = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.INSTRUCTOR_GET_ALL_MODULES_LIST(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('INSTRUCTOR_GET_ALL_MODULES_LIST => ', response.data);

        const parsedObj = ParsedAllModulesPageData(response.data.modules);
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_GET_ALL_MODULES_LIST, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const plannerPageMarkDayOff = async (batchCode, moduleName, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PLANNER_PAGE_MARK_DAY_OFF(batchCode, moduleName), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PLANNER_PAGE_MARK_DAY_OFF response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PLANNER_PAGE_MARK_DAY_OFF(batchCode, moduleName))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}
const rescheduleCertificationDate = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.patch(EndPoints.RESCHEDULE_CERTIFICATION_DATE, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PLANNER_PAGE_MARK_DAY_OFF response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            // return Promise.reject({
            //     error: ParsedError(error, EndPoints.PLANNER_PAGE_MARK_DAY_OFF(batchCode, moduleName))
            // });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updateTopicData = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.UPDATE_TOPIC_DATA(topicId), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('UPDATE_TOPIC_DATA response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_TOPIC_DATA(topicId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const updateSessionPlanData = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_UPDATE_SESSOIN_PLAN(topicId), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('CREATE_UPDATE_SESSOIN_PLAN response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_UPDATE_SESSOIN_PLAN(topicId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getEvaluationPageDetails = async (batchCode, moduleName, forPMPage) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EVALUATION_PAGE_GET_ALL_SUBMISSIONS(batchCode, moduleName), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('EVALUATION_PAGE_GET_ALL_SUBMISSIONS => ', response.data);

        const parsedObj = ParsedEvaluationCardsData(response.data, forPMPage);
        let updatedResponse = null;

        if (forPMPage === true) {
            updatedResponse = {
                ...parsedObj,
                ongoingProgram: {
                    programId: 123,
                    programBatchCode: 'FSR160421',
                    programName: 'Full Stack Developer Program',
                    programProgress: 45,
                    type: '',
                    isActive: true,
                    startDate: 'date'
                }
            }
        } else {
            updatedResponse = parsedObj;
        }
        response.data = updatedResponse;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EVALUATION_PAGE_GET_ALL_SUBMISSIONS(batchCode, moduleName))
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const deleteSubtopic = async (subtopicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_SUBTOPIC(subtopicId), { headers: { 'Authorization': token } })
        .then(res => {
            // Log('DELETE_SUBTOPIC response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_SUBTOPIC(subtopicId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getQuizSubmissionMetaData = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EVALUATION_PAGE_GET_QUIZ_SUBMISSION_META_DATA(quizId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('EVALUATION_PAGE_GET_QUIZ_SUBMISSION_META_DATA => ', response.data);

        const parsedObj = ParsedQuizSubmissionMetadata(response.data.quiz);
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EVALUATION_PAGE_GET_QUIZ_SUBMISSION_META_DATA(quizId))
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getQuizStudentSubmissionsList = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EVALUATION_PAGE_GET_QUIZ_STUDENT_SUBMISSIONS_LIST(quizId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('EVALUATION_PAGE_GET_QUIZ_STUDENT_SUBMISSIONS_LIST => ', response.data.submissions.sumissions);

        const parsedObj = ParsedQuizStudentSubmissionsList(response.data.submissions.submissions, 'quiz');
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EVALUATION_PAGE_GET_QUIZ_STUDENT_SUBMISSIONS_LIST(quizId))
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getAssignmentSubmissionMetaData = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EVALUATION_PAGE_GET_ASSIGNMENT_SUBMISSION_META_DATA(quizId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('EVALUATION_PAGE_GET_ASSIGNMENT_SUBMISSION_META_DATA => ', response.data);

        const parsedObj = ParsedQuizSubmissionMetadata(response.data.assignments);
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EVALUATION_PAGE_GET_ASSIGNMENT_SUBMISSION_META_DATA(quizId))
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getAssignmentStudentSubmissionsList = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EVALUATION_PAGE_GET_ASSIGNMENT_STUDENT_SUBMISSIONS_LIST(quizId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('EVALUATION_PAGE_GET_ASSIGNMENT_STUDENT_SUBMISSIONS_LIST => ', response.data.submissions.sumissions);

        const parsedObj = ParsedQuizStudentSubmissionsList(response.data.submissions.submissions, 'assignment');
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            Log('EVALUATION_PAGE_GET_ASSIGNMENT_STUDENT_SUBMISSIONS_LIST Error => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.EVALUATION_PAGE_GET_ASSIGNMENT_STUDENT_SUBMISSIONS_LIST(quizId))
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getAssignmentStudentSubmissionsData = async (assignmentId, userId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_STUDENT_ASSIGNMENT_SUBMISSIONS_DATA(assignmentId, userId), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_STUDENT_ASSIGNMENT_SUBMISSIONS_DATA => ', response.data);

        const parsedResponse = ParseAssignmentStudentSubmissionData(response.data);

        const parsedObj = {
            assignmentDetails: parsedResponse.assignmentDetails,
            problemsList: parsedResponse.problemsList,
            overallScoreData: parsedResponse.overallScoreData
        }
        response.data = parsedObj;
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_STUDENT_ASSIGNMENT_SUBMISSIONS_DATA(assignmentId, userId))
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const assignStudentGrades = async (assignmentId, userId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.GRADE_STUDENT_ASSIGNMENT(assignmentId, userId), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('GRADE_STUDENT_ASSIGNMENT response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GRADE_STUDENT_ASSIGNMENT(assignmentId, userId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const startInstructorLiveSession = async (liveSessionId, startedBy) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.START_LIVE_SESSION(liveSessionId, startedBy), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('START_LIVE_SESSION response => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.START_LIVE_SESSION)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const endInstructorLiveSession = async (liveSessionId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.END_LIVE_SESSION(liveSessionId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('END_LIVE_SESSION response => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.END_LIVE_SESSION)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getLearnerLiveSessionData = async (liveSessionId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_LIVE_SESSION_DATA(liveSessionId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_LIVE_SESSION_DATA response => ', response.data);
            const parsedData = ParsedLiveSessionData(response.data.live_session);
            response.data = parsedData;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_LIVE_SESSION_DATA)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const markStudentAttendance = async (liveSessionId, data) => {
    // ----------- For Students to mark their own attendance ------------
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.MARK_STUDENT_ATTENDANCE(liveSessionId), data, { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('MARK_STUDENT_ATTENDANCE response => ', response.data);
            // const parsedData = ParsedLiveSessionData(response.data.live_session);
            // response.data = parsedData;
            return response;
        })
        .catch(error => {
            console.log("attendance error => ", error)
            return Promise.reject({
                error: error
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorDailyFeedbackReport = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_DAILY_FEEDBACK_REPORT(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_DAILY_FEEDBACK_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}
const getInstructorDailyFeedbackReportOnPageLoad = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_DAILY_FEEDBACK_REPORT_ON_PAGE_LOAD(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('getInstructorDailyFeedbackReportOnPageLoad API response => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportDataOnPageLoad(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            console.log('getInstructorDailyFeedbackReportOnPageLoad API error => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorDailyFeedbackReportOnPageLoadNew = async (batchCode, moduleName, startDate, endDate) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_DAILY_FEEDBACK_REPORT_ON_PAGE_LOAD_NEW(batchCode, moduleName, startDate, endDate), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('NEW FB ON LOAD API response => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportDataOnPageLoadNew(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            console.log('getInstructorDailyFeedbackReportOnPageLoad API error => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT_ON_PAGE_LOAD_NEW)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getPMDailyFeedbackReportOnPageLoad = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_DAILY_FEEDBACK_REPORT_ON_PAGE_LOAD(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('getInstructorDailyFeedbackReportOnPageLoad API response => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportDataOnPageLoad(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            console.log('getPMDailyFeedbackReportOnPageLoad API error => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorOverallFeedbackReportNew = async (batchCode, moduleName, startDate, endDate) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTOR_OVERALL_FEEDBACK_REPORT_NEW(batchCode, moduleName, startDate, endDate), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('lulululululululuulu => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportDataOverallNew(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_INSTRUCTOR_OVERALL_FEEDBACK_REPORT_NEW)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}
const getInstructorOverallFeedbackReport = async (batchCode, moduleName, duration) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTOR_OVERALL_FEEDBACK_REPORT(batchCode, moduleName, duration), { headers: { 'Authorization': token } })
        .then(response => {
            console.log('GET_DAILY_FEEDBACK_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportDataOverall(response.data, duration);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getPMOverallFeedbackReport = async (batchCode, moduleName, duration) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_OVERALL_FEEDBACK_REPORT(batchCode, moduleName, duration), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_DAILY_FEEDBACK_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorDailyFeedbackReportDataOverall(response.data, duration);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorDailyFeedbackReportForTopic = async (batchCode, moduleName, topicId, feedbackType) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_DAILY_FEEDBACK_REPORT_FOR_TOPIC(batchCode, moduleName, topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_DAILY_FEEDBACK_REPORT_FOR_TOPIC response => ', response.data);
            const parsedObj = ParsedInstructorDailyTopicFeedbackReport(response.data);
            response.data = parsedObj;

            // console.log(parsedObj)


            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_REPORT_FOR_TOPIC)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}


const getDailyFeedbackStudentsListForTopic = async (topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_DAILY_FEEDBACK_STUDENTS_LIST_FOR_TOPIC(topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_DAILY_FEEDBACK_STUDENTS_LIST_FOR_TOPIC response => ', response.data);
            const parsedObj = ParsedDailyFeedbackStudentsList(response.data.submissions);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_DAILY_FEEDBACK_STUDENTS_LIST_FOR_TOPIC)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getStudentDailyFeedbackResponse = async (topicId, userId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_STUDENT_DAILY_FEEDBACK_RESPONSE(topicId, userId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_STUDENT_DAILY_FEEDBACK_RESPONSE response => ', response.data);
            const parsedObj = ParsedStudentDailyFeedbackResponse(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_STUDENT_DAILY_FEEDBACK_RESPONSE)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorWeeklyFeedbackReport = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_WEEKLY_FEEDBACK_REPORT(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_WEEKLY_FEEDBACK_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorWeeklyFeedbackReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_WEEKLY_FEEDBACK_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getFeedbackReportForParticularWeek = async (batchCode, moduleName, topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_FEEDBACK_REPORT_FOR_A_WEEK(batchCode, moduleName, topicId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_FEEDBACK_REPORT_FOR_A_WEEK response => ', response.data);
            const parsedObj = ParsedInstructorWeeklyFeedbackReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_FEEDBACK_REPORT_FOR_A_WEEK)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}


const getStudentWeeklyFeedbackResponse = async (feedbackId, userId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_STUDENT_WEEKLY_FEEDBACK_RESPONSE(feedbackId, userId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_STUDENT_WEEKLY_FEEDBACK_RESPONSE response => ', response.data);
            const parsedObj = ParsedStudentWeeklyFeedbackResponse(response.data.submission);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_STUDENT_WEEKLY_FEEDBACK_RESPONSE)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorOverallReport = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTOR_OVERALL_REPORT(batchCode, moduleName), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_INSTRUCTOR_OVERALL_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorOverallReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_INSTRUCTOR_OVERALL_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorClassGradesReport = async (batchCode, moduleName, full) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTOR_CLASS_GREADES_REPORT(batchCode, moduleName, full), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_INSTRUCTOR_CLASS_GREADES_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorClassGradesReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_INSTRUCTOR_CLASS_GREADES_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorAttendanceReport = async (batchCode, moduleName, full) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTOR_ATTENDANCE_REPORT(batchCode, moduleName, full), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_INSTRUCTOR_ATTENDANCE_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorAttendanceReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_INSTRUCTOR_ATTENDANCE_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}

const getInstructorStudentAttendanceReport = async (batchCode, moduleName, full) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_STUDENT_ATTENDANCE_REPORT(batchCode, moduleName, full), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log('GET_STUDENT_ATTENDANCE_REPORT response => ', response.data);
            const parsedObj = ParsedInstructorStudentAttendanceReportData(response.data);
            response.data = parsedObj;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_STUDENT_ATTENDANCE_REPORT)
            })
        })

    return Promise.resolve({
        result: response.data
    })
}


const getLearnerQuizSubmissionResponses = async (quizId, userId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_LEARNER_SUBMISSION_QUIZ_RESPONSES(quizId, userId), { headers: { 'Authorization': token } })
        .then(res => {
            // Log('GET_LEARNER_SUBMISSION_QUIZ_RESPONSES Response => ', res);
            let updatedResponse = ParsedStudentQuizSubmission(res.data);
            res.data = updatedResponse;
            return res;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_LEARNER_SUBMISSION_QUIZ_RESPONSES(quizId, userId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

// const getPMHomepageData = async () => {
//     const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
//     let response = await axios.get(EndPoints.GET_PM_HOMEPAGE_DATA, { headers: { 'Authorization': token } })

//         .then(response => {
//             // Log('GET_PROGRAM_MANAGER_HOMEPAGE_DATA => ', response);

//             let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
//             AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

//             const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';

//             let updatedResponse = {
//                 pmHomepageData: ParsedPMHomepageData(response.data),
//                 userDetails: {
//                     profilePic: profilePic,
//                     username: response.data.user.username,
//                     userId: response.data.user.id,
//                     email: response.data.user.email,
//                     fullName: fullName,
//                     unreadNotifCount: response.data.unread_notif_count,
//                     accessInstructorReports: response.data.access_instructor_reports,
//                 }
//             }
//             response.data = updatedResponse;
//             return response;
//         })
//         .catch(error => {
//             // Error(error.response);
//             // console.log('Error Catch => ', error)
//             return Promise.reject({
//                 error: ParsedError(error, EndPoints.GET_PM_HOMEPAGE_DATA)
//             });
//         })
//     return Promise.resolve({
//         result: response.data
//     });
// }

const getProgramManagerData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_DATA, { headers: { 'Authorization': token } })
        .then((response) => {
            let profilePic = !IsStringEmpty(response.data.user.profilepicture_url) ? response.data.user.profilepicture_url : defaultAvatar;
            AddInLocalStorage(Constants.KEY_PROFILE_PIC, profilePic);

            const fullName = !IsStringEmpty(response.data.user.first_name) ? (response.data.user.first_name + ' ' + response.data.user.last_name) : '';
            let updatedResponse = {
                userDetails: {
                    profilePic: profilePic,
                    username: response.data.user.username,
                    userId: response.data.user.id,
                    email: response.data.user.email,
                    fullName: fullName,
                    unreadNotifCount: response.data.unread_notif_count,
                    accessInstructorReports: response.data.access_instructor_reports,
                }
            }
            response.data = updatedResponse;
            return response;
        })
        .catch((error) => {
            console.log('Error: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMHomepageStats = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_HOMEPAGE_STATS, { headers: { 'Authorization': token } })
        .then(response => {
            response.data = ParsedPMHomepageStats(response.data);
            return response;
        })
        .catch(error => {
            console.log('errorr: ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_HOMEPAGE_STATS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMHomepageOngoingModulesData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_HOMEPAGE_ONGOING_MODULES_DATA, { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PROGRAM_MANAGER_HOMEPAGE_DATA => ', 

            let updatedResponse = {
                ongoingModulesData: ParsedPMHomepageOngoingModulesData(response.data),
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_HOMEPAGE_ONGOING_MODULES_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMLearnerOverallStats = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_LEARNER_OVERALL_STATS(batchCode), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_LEARNER_OVERALL_STATS => ', response.data);

            let updatedResponse = {
                activeStudents: !IsStringEmpty(response.data.active_students) ? response.data.active_students : '-',
                totalStudents: !IsStringEmpty(response.data.total_students) ? response.data.total_students : '-',
                activePercentage: !IsStringEmpty(response.data.active_students) && !IsStringEmpty(response.data.active_students) ? calcPercentage(response.data.active_students, response.data.total_students) : '',
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_LEARNER_OVERALL_STATS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMAllLeanersList = async (pageNum, batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_ALL_LEARNERS_LIST(pageNum, batchCode), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_ALL_LEARNERS_LIST => ', response.data);

            let updatedResponse = {
                learnersList: ParsedPMAllLearnersList(response.data.results),
                count: response.data.count
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_ALL_LEARNERS_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMLeanersSearchResults = async (searchQuery, pageNum, batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_LEARNERS_SEARCH_LIST(searchQuery, pageNum, batchCode), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_LEARNERS_SEARCH_LIST => ', response.data);

            let updatedResponse = {
                learnersList: ParsedPMAllLearnersList(response.data.results),
                count: response.data.count
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_LEARNERS_SEARCH_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMProgramsList = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_PROGRAMS_LIST, { headers: { 'Authorization': token } })

        .then(response => {
            Log('GET_PM_PROGRAMS_LIST => ', response.data);

            let programsList = ParsedPMAllProgramsList(response.data.programs);

            response.data = programsList;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_PROGRAMS_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const addNewLearnerPM = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PM_ADD_NEW_LEARNER, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PM_ADD_NEW_LEARNER Response', res.data);
            return res;
        })
        .catch(error => {
            // Log('PM_ADD_NEW_LEARNER ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PM_ADD_NEW_LEARNER, APICodes.UPDATE_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const autoEnrollLearner = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PM_AUTO_ENROLL_LEARNER, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PM_AUTO_ENROLL_LEARNER Response', res.data);
            return res;
        })
        .catch(error => {
            Log('PM_AUTO_ENROLL_LEARNER ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PM_AUTO_ENROLL_LEARNER, APICodes.UPDATE_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMInstructorOverallStats = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_INSTRUCTOR_OVERALL_STATS, { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_INSTRUCTOR_OVERALL_STATS => ', response.data);

            let updatedResponse = {
                activeInstructors: !IsStringEmpty(response.data.active_instructors) ? response.data.active_instructors : '-',
                totalInstructors: !IsStringEmpty(response.data.total_instructors) ? response.data.total_instructors : '-'
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_INSTRUCTOR_OVERALL_STATS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMAllInstructorsList = async (pageNum) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_ALL_INSTRUCTORS_LIST(pageNum), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_ALL_INSTRUCTORS_LIST => ', response.data);

            let updatedResponse = {
                instructorsList: ParsedPMAllInstructorsList(response.data.results),
                count: response.data.count
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_ALL_INSTRUCTORS_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMInstructorSearchResults = async (searchQuery, pageNum) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_INSTRUCTORS_SEARCH_LIST(searchQuery, pageNum), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_INSTRUCTORS_SEARCH_LIST => ', response.data);

            let updatedResponse = {
                instructorsList: ParsedPMAllInstructorsList(response.data.results),
                count: response.data.count
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_INSTRUCTORS_SEARCH_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const getPMSearchProgram = async (searchQuery) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_SEARCH_PROGRAM(searchQuery), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_INSTRUCTORS_SEARCH_LIST => ', response.data);

            let updatedResponse = {
                updatedProgramsList: ParseSearchProgramsData(response.data.programs),
                count: response.data.count
            }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_SEARCH_PROGRAM)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}



const getPMProgramsListInstructor = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_PROGRAMS_LIST_INSTRUCTOR, { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_PROGRAMS_LIST_INSTRUCTOR => ', response.data);

            let updatedResponse = {
                programsList: ParsedPMAllProgramsList(response.data.programs),
                modulesList: ParsedPMAllModulesList(response.data.modules)
            };

            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_PROGRAMS_LIST_INSTRUCTOR)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMProgramModulesList = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_MODULES_LIST_INSTRUCTOR(batchCode), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_MODULES_LIST_INSTRUCTOR => ', response.data);

            let updatedResponse = {
                modulesList: ParsedPMAllModulesList(response.data.modules)
            };

            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_MODULES_LIST_INSTRUCTOR)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const addNewInstructorPM = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PM_ADD_NEW_INSTRUCTOR, data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PM_ADD_NEW_INSTRUCTOR Response', res.data);
            return res;
        })
        .catch(error => {
            // Log('PM_ADD_NEW_INSTRUCTOR ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PM_ADD_NEW_INSTRUCTOR)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const downloadLearnerTemplate = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DOWNLOAD_TEMPLATE_FILE_LEARNER, { headers: { 'Authorization': token } })

        .then(response => {
            // Log('DOWNLOAD_TEMPLATE_FILE_LEARNER Data => ', response.data);

            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.DOWNLOAD_TEMPLATE_FILE_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const downloadInstructorTemplate = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DOWNLOAD_TEMPLATE_FILE_INSTRUCTOR, { headers: { 'Authorization': token } })

        .then(response => {
            // Log('DOWNLOAD_TEMPLATE_FILE_INSTRUCTOR Data => ', response.data);

            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.DOWNLOAD_TEMPLATE_FILE_INSTRUCTOR)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const bulkUploadLearner = async (file) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.BULK_UPLOAD_LEARNER, file, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('BULK_UPLOAD_LEARNER Response', res.data);
            return res;
        })
        .catch(error => {
            Log('BULK_UPLOAD_LEARNER ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.BULK_UPLOAD_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}
const addRCRMSlugInBulk = async (file) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.BULK_ADD_RCRM_SLUG, file, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('BULK_UPLOAD_LEARNER Response', res.data);
            return res;
        })
        .catch(error => {
            Log('BULK_UPLOAD_LEARNER ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.BULK_UPLOAD_LEARNER)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const bulkUploadInstructor = async (file) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.BULK_UPLOAD_INSTRUCTOR, file, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('BULK_UPLOAD_INSTRUCTOR Response', res.data);
            return res;
        })
        .catch(error => {
            // Log(.BULK_UPLOAD_INSTRUCTOR ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.BULK_UPLOAD_INSTRUCTOR)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getUserAccountData = async (username) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_USER_ACCOUNT_DETAILS(username), { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_USER_ACCOUNT_DETAILS Data => ', response.data);
            const updatedResponse = ParsedUserAccountData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_USER_ACCOUNT_DETAILS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const saveUserAccountSettings = async (username, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.SAVE_USER_ACCOUNT_DETAILS(username), data, { headers: { 'Authorization': token } })
        .then(response => {
            Log('SAVE_USER_ACCOUNT_DETAILS Response', response.data);
            const updatedResponse = ParsedUserAccountData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            Log('SAVE_USER_ACCOUNT_DETAILS ERROR => ', error);
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.SAVE_USER_ACCOUNT_DETAILS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getAllProgramsPageData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_ALL_PROGRAMS_DATA, {
        headers: {
            'Authorization': token
        }
    })

        .then(response => {
            // Log('GET_PM_ALL_PROGRAMS_DATA Data => ', response.data);
            const updatedResponse = ParsedPMAllProgramsData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_ALL_PROGRAMS_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPaginatedProgramsListData = async (pageNumber) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_PAGINATED_PROGRAMS_LIST(pageNumber), {
        headers: {
            'Authorization': token
        }
    })

        .then(response => {
            // Log('GET_PM_ALL_PROGRAMS_DATA Data => ', response.data);
            const updatedResponse = parsePaginatedProgramsData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_PAGINATED_PROGRAMS_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMFilteredPaginatedData = async (pageNum, status) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_PAGINATED_FILTERED_PROGRAMS_LIST(pageNum, status), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_INSTRUCTORS_SEARCH_LIST => ', response.data);

            const updatedResponse = parseFilteredPaginatedProgramsData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_PAGINATED_FILTERED_PROGRAMS_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const getPMInstructorPerformanceData = async (username) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_INSTRUCTOR_PERFORMANCE_DATA(username), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_INSTRUCTOR_PERFORMANCE_DATA => ', response.data);

            let updatedResponse = ParsedPMInstructorPerformanceData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_INSTRUCTOR_PERFORMANCE_DATA(username))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getPMInstructorModulePerformanceData = async (username, moduleName, batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_INSTRUCTOR_MODULE_PERFORMANCE_DATA(username, moduleName, batchCode), { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_INSTRUCTOR_MODULE_PERFORMANCE_DATA => ', response.data);

            let updatedResponse = ParsedPMInstructorPerformanceData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_INSTRUCTOR_MODULE_PERFORMANCE_DATA(username, moduleName, batchCode))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getProgramListData = async (programName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_PROGRAMS_LIST_DATA(programName), {
        headers: {
            'Authorization': token
        }
    })
        .then(response => {
            //  console.log('GET_PM_PROGRAMS_LIST_DATA Data => ', response.data);
            const updatedResponse = ParsedPMAllProgramsData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_PROGRAMS_LIST_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getProgramOverviewData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PROGRAM_OVERVIEW_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    })
        .then(response => {
            // Log('GET_PROGRAM_OVERVIEW_DATA Data => ', response.data);
            const updatedResponse = ParsedProgramsOverviewData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PROGRAM_OVERVIEW_DATA)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getCurriculumOverviewData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CURRICULUM_OVERVIEW_DATA(batchCode, moduleName),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            Log('GET_CURRICULUM_OVERVIEW_DATA => ', response.data);
            const updatedResponse = ParsedCurriculumOverviewData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CURRICULUM_OVERVIEW_DATA)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}


const getInstructorsData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_INSTRUCTORS_DATA(batchCode),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('GET_INSTRUCTORS_DATA => ', response.data);
            const updatedResponse = ParsedInstructorsData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_INSTRUCTORS_DATA)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteCurriculumTopic = async (topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_CURRICULUM_TOPIC(topicId),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('DELETE_CURRICULUM_TOPIC => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_CURRICULUM_TOPIC)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getAllModulesListForProgram = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_ALL_MODULES_LIST_FOR_PROGRAM(batchCode), { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_ALL_MODULES_LIST_FOR_PROGRAM => ', response.data);
            const updatedResponse = ParsedAllModulesDataForProgram(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Log('GET_ALL_MODULES_LIST_FOR_PROGRAM ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_ALL_MODULES_LIST_FOR_PROGRAM)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getModulePerformanceData = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_MODULE_PERFORMANCE_DATA(batchCode, moduleName),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('GET_MODULE_PERFORMANCE_DATA => ', response.data);
            const updatedResponse = ParsedModulePerformanceData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_MODULE_PERFORMANCE_DATA)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getEditModuleList = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_EDIT_MODULE_LIST(batchCode),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('GET_EDIT_MODULE_LIST => ', response.data);
            const updatedResponse = ParsedAllModulesDataForProgram(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_EDIT_MODULE_LIST)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteModule = async (moduleId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_MODULE(moduleId),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('DELETE_MODULE => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_MODULE)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getAllProgramTemplatesList = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_ALL_PROGRAM_TEMPLATES_LIST, { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_ALL_PROGRAM_TEMPLATES_LIST => ', response.data);
            const updatedResponse = ParsedEnrolledPrograms(response.data.templates);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            Log('GET_ALL_PROGRAM_TEMPLATES_LIST ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_ALL_PROGRAM_TEMPLATES_LIST)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getAllModuleTemplatesList = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_ALL_MODULE_TEMPLATES_LIST, { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_ALL_MODULE_TEMPLATES_LIST => ', response.data);
            const updatedResponse = ParsedModuleTempalteList(response.data.modules);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            Log('GET_ALL_MODULE_TEMPLATES_LIST ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_ALL_MODULE_TEMPLATES_LIST)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const certificationViewReports = async (certificationCode, dateObject) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CERTIFICATION_VIEW_REPORTS(certificationCode, dateObject.schedule_date, dateObject.end_date), dateObject, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_VIEW_REPORTS=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_VIEW_REPORTS)
            });
        })
    return Promise.resolve({
        result: response.data
    });

}
const UpdateNotAttemptedStatus = async (certificationCode, data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.UPDATE_NOT_ATTEMPTED_STATUS(certificationCode), data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('UPDATE_NOT_ATTEMPTED_STATUS ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_NOT_ATTEMPTED_STATUS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}
const getBatchmatesList = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_BATCHMATES_DETAILS(batchCode), { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_BATCHMATES_DETAILS => ', response.data);
            const updatedResponse = { batchmateDetails: ParsedBatchmateDetails(response.data).updatedList, groupNames: response.data.groups, badges: response.data.badges }
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            Log('GET_ALL_MODULE_TEMPLATES_LIST ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_BATCHMATES_DETAILS)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const getUpcomingCertificationDetails = async (userId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_HOMEPAGE_UPCOMING_CERTIFICATION(userId), { headers: { 'Authorization': token } })
        .then(response => {
            // console.log(response)
            // Log('GET_HOMEPAGE_UPCOMING_CERTIFICATION => ', response);
            const updatedResponse = ParsedUpcomingCertificates(response.data)
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            Log('GET_HOMEPAGE_UPCOMING_CERTIFICATION=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_BATCHMATES_DETAILS)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const getGroupData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_GROUP_DETAILS(batchCode), { headers: { 'Authorization': token } })
        .then(response => {
            Log('GET_GROUP_DETAILS => ', response.data);
            const updatedResponse = ParsedGroupDetails(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            Log('GET_ALL_MODULE_TEMPLATES_LIST ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_GROUP_DETAILS)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getLiveSessionScheduleData = async (date) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_LIVE_SESSION_SCHEDULE(date),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('GET_PM_LIVE_SESSION_SCHEDULE => ', response.data);
            const updatedResponse = ParsedLiveSessionScheduleData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_LIVE_SESSION_SCHEDULE)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getProgramTemplateDetails = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.PROGRAM_TEMPLATE_DETAILS(batchCode),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('PROGRAM_TEMPLATE_DETAILS => ', response.data);
            const updatedResponse = ParsedProgramTemplateData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.PROGRAM_TEMPLATE_DETAILS)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const cloneProgramFromTemplate = async (batchCode, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PROGRAM_TEMPLATE_DETAILS(batchCode), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CLONE PROGRAM_TEMPLATE_DETAILS => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.PROGRAM_TEMPLATE_DETAILS)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getModuleTemplateDetails = async (batchCode, moduleName) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MODULE_TEMPLATE_DETAILS(batchCode, moduleName),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('MODULE_TEMPLATE_DETAILS => ', response.data);
            const updatedResponse = ParsedModuleTemplateData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULE_TEMPLATE_DETAILS(batchCode, moduleName))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const cloneModuleFromTemplate = async (batchCode, moduleName, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.MODULE_TEMPLATE_DETAILS(batchCode, moduleName), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CLONE MODULE_TEMPLATE_DETAILS => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.MODULE_TEMPLATE_DETAILS(batchCode, moduleName))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const unenrollLearnerFromProgram = async (batchCode, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.UNENROLL_LEARNER(batchCode), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log(' UNENROLL_LEARNER => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.UNENROLL_LEARNER(batchCode))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const updateStudentBatchStatus = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    console.log(EndPoints.UPDATE_STUDENT_BATCH_STATUS)
    let response = await axios.post(EndPoints.UPDATE_STUDENT_BATCH_STATUS, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log(' UPDATE_STUDENT_BATCH_STATUS => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_STUDENT_BATCH_STATUS)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getProgramPerformanceAttendanceData = async (batchCode, moduleName, viewBy) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PROGRAM_PERFORMANCE_ATTENDANCE_DATA(batchCode, moduleName, viewBy),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_PROGRAM_PERFORMANCE_ATTENDANCE_DATA => ', response.data);
            let updatedResponse;
            viewBy === 'weeks' ? updatedResponse = ParsedPerformanceAttendanceByWeeks(response.data) : updatedResponse = ParsedPerformanceAttendanceByMonths(response.data)
            response.data = updatedResponse
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PROGRAM_PERFORMANCE_ATTENDANCE_DATA(batchCode, moduleName))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getProgramPerformanceClassGradesData = async (batchCode, moduleName, viewBy) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PROGRAM_PERFORMANCE_CLASSGRADES_DATA(batchCode, moduleName, viewBy),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_PROGRAM_PERFORMANCE_CLASSGRADES_DATA => ', response.data);
            let updatedResponse;
            viewBy === 'weeks' ? updatedResponse = ParsedPerformanceClassGradesByWeeks(response.data) : updatedResponse = ParsedPerformanceClassGradesByMonths(response.data)
            response.data = updatedResponse
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PROGRAM_PERFORMANCE_CLASSGRADES_DATA(batchCode, moduleName))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getEditProgramFormDetails = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EDIT_PROGRAM_FORM_DATA(batchCode),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET EDIT_PROGRAM_FORM_DATA => ', response.data);
            const updatedResponse = ParsedEditProgramData(response.data);
            response.data = updatedResponse
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EDIT_PROGRAM_FORM_DATA(batchCode))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const editProgramFormDetails = async (batchCode, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.EDIT_PROGRAM_FORM_DATA(batchCode), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('EDIT_PROGRAM_FORM_DATA => ', response.data);
            return response;
        })
        .catch(error => {
            Log('EDIT_PROGRAM_FORM_DATA ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.EDIT_PROGRAM_FORM_DATA(batchCode))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getEditModuleFormDetails = async (moduleId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.EDIT_MODULE_FORM_DATA(moduleId),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('EDIT_MODULE_FORM_DATA => ', response.data);
            const updatedResponse = ParsedModuleTemplateData(response.data, true);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EDIT_MODULE_FORM_DATA(moduleId))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const editModuleFormDetails = async (moduleId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.EDIT_MODULE_FORM_DATA(moduleId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('EDIT_MODULE_FORM_DATA => ', response.data);
            // const updatedResponse = ParsedModuleTemplateData(response.data, true);
            // response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EDIT_MODULE_FORM_DATA(moduleId))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteQuizSubmissions = async (quizId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.DELETE_QUIZ_SUBMISSIONS(quizId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            Log('DELETE_QUIZ_SUBMISSIONS => ', response.data);
            return response;
        })
        .catch(error => {
            Log('DELETE_QUIZ_SUBMISSIONS ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_QUIZ_SUBMISSIONS(quizId))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteAssignmentSubmissions = async (assignmentId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.DELETE_ASSIGNMENT_SUBMISSIONS(assignmentId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('DELETE_ASSIGNMENT_SUBMISSIONS => ', response.data);
            return response;
        })
        .catch(error => {
            Log('DELETE_ASSIGNMENT_SUBMISSIONS ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_ASSIGNMENT_SUBMISSIONS(assignmentId))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const markLearnerAttendance = async (data) => {
    // ----------- for Program Manager ------------
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.MARK_LEARNER_ATTENDANCE, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('MARK_LEARNER_ATTENDANCE => ', response.data);
            return response;
        })
        .catch(error => {
            // Log('MARK_LEARNER_ATTENDANCE ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.MARK_LEARNER_ATTENDANCE)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}


const createNewModule = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_NEW_MODULE, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CREATE_NEW_MODULE => ', response.data);
            return response;
        })
        .catch(error => {
            // Log('CREATE_NEW_MODULE ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_NEW_MODULE)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const certificationEnrollment = async (data, batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CERTIFICATION_ENROLLMENT(batchCode), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_ENROLLMENT)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const copyLiveSessionDetail = async (data, liveSessionId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.COPY_LIVE_SESSION_DETAIL(liveSessionId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.COPY_LIVE_SESSION_DETAIL)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const editLiveSessionDetail = async (data, liveSessionId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.EDIT_LIVE_SESSION_DETAIL(liveSessionId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EDIT_LIVE_SESSION_DETAIL)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const getPMCertificationList = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_PM_CERTIFICATIONS_LIST, { headers: { 'Authorization': token } })

        .then(response => {
            // Log('GET_PM_CERTIFICATIONS_LIST => ', response.data);
            let updatedResponse = {
                certificationList: ParsedPMAllCertificationList(response.data.certifications_list),
                roundList: ParsedPMAllRoundList(response.data.rounds_list)
            };

            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            // console.log('Error Catch => ', error)
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PM_CERTIFICATIONS_LIST)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getNewModuleDetails = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CREATE_NEW_MODULE,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET CREATE_NEW_MODULE => ', response.data);
            const updatedResponse = ParsedModuleTemplateData(response.data, false);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Log('GET CREATE_NEW_MODULE ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_NEW_MODULE)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getInstructorDailyFeedbackReportPM = async (instructor, duration) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.INSTRUCTOR_DAILY_FEEDBACK_REPORT_PM(instructor, duration),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET INSTRUCTOR_DAILY_FEEDBACK_REPORT_PM => ', response.data);
            const updatedResponse = ParsedInstructorDailyFeedbackReportPM(response.data, duration);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Log('GET INSTRUCTOR_DAILY_FEEDBACK_REPORT_PM ERROR => ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.INSTRUCTOR_DAILY_FEEDBACK_REPORT_PM(instructor, duration))
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getProgramManagersList = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CREATE_NEW_PROGRAM,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CREATE_NEW_PROGRAM => ', response.data);
            const updatedResponse = ParsedProgramTemplateData(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_NEW_PROGRAM)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const createNewProgram = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_NEW_PROGRAM, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CLONE CREATE_NEW_PROGRAM => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_NEW_PROGRAM)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getMdInstructors = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_MD_INSTRUCTORS, { headers: { 'Authorization': token } })
        .then(res => res)
        .catch(error => Promise.reject({ error: ParsedError(error, EndPoints.GET_MD_INSTRUCTORS) }));
    return Promise.resolve({ result: response.data });
}

const getSyncSpeaker = async (syncId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.SYNC_SPEAKER(syncId), { headers: { 'Authorization': token } })
        .then(res => res)
        .catch(error => Promise.reject({ error: ParsedError(error, EndPoints.SYNC_SPEAKER(syncId)) }));
    return Promise.resolve({ result: response.data });
}

const setSyncSpeaker = async (syncId, instructorId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.patch(EndPoints.SYNC_SPEAKER(syncId), { instructor_id: instructorId }, { headers: { 'Authorization': token } })
        .then(res => res)
        .catch(error => Promise.reject({ error: ParsedError(error, EndPoints.SYNC_SPEAKER(syncId)) }));
    return Promise.resolve({ result: response.data });
}

const createSync = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_SYNC, data, { headers: { 'Authorization': token } })
        .then(res => res)
        .catch(error => Promise.reject({ error: ParsedError(error, EndPoints.CREATE_SYNC) }));
    return Promise.resolve({ result: response.data });
}

const getSyncList = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_SYNC_LIST, { headers: { 'Authorization': token } })
        .then(res => res)
        .catch(error => Promise.reject({ error: ParsedError(error, EndPoints.GET_SYNC_LIST) }));
    return Promise.resolve({ result: response.data });
}

const updateSyncSeats = async (syncId, seatsLeft) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.patch(EndPoints.SYNC_SEATS(syncId), { seats_left: seatsLeft }, { headers: { 'Authorization': token } })
        .then(res => res)
        .catch(error => Promise.reject({ error: ParsedError(error, EndPoints.SYNC_SEATS(syncId)) }));
    return Promise.resolve({ result: response.data });
}

const editAssignmentSubmission = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.EDIT_ASSIGNMENT_SUBMISSION(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('assignment submission response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.EDIT_ASSIGNMENT_SUBMISSION(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const deleteAssignment = async (topicId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_ASSIGNMENT(topicId),
        {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            // Log('DELETE_ASSIGNMENT => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_ASSIGNMENT)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteQuiz = async (quizId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_QUIZ(quizId),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('DELETE_QUIZ => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_QUIZ)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteQuizProblem = async (problemId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_QUIZ_PROBLEM(problemId),
        { headers: { 'Authorization': token } })
        .then(response => {
            Log('DELETE_QUIZ_PROBLEM => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_QUIZ_PROBLEM)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const deleteGradingCriteria = async (gradingCriteriaId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_GRADING_CRITERIA(gradingCriteriaId),
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('DELETE_GRADING_CRITERIA => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_GRADING_CRITERIA)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}
const deleteEducation = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.DELETE_EDUCATION, data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        return response
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}
const deleteWorkExperience = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.DELETE_WORK_EXPERIENCE, data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        return response
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}
const deleteAccomplishments = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.DELETE_ACCOMPLISHMENTS, data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        return response
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}

const addResourcesPDF = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.ADD_RESOURCES_PDF(topicId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('ADD_RESOURCES_PDF => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.ADD_RESOURCES_PDF)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const addResourcesSlides = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.ADD_RESOURCES_SLIDES(topicId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('ADD_RESOURCES_PDF => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.ADD_RESOURCES_PDF)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const addResourcesOtherFile = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.ADD_RESOURCES_OTHER_FILE(topicId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('ADD_RESOURCES_PDF => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.ADD_RESOURCES_PDF)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}


const addEmbedResourceLink = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.ADD_RESOURCES_EMBED_LINK(topicId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            Log('ADD_RESOURCES_EMBED_LINK => ', response.data);
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.ADD_RESOURCES_EMBED_LINK)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}


const getVideoUploadSignature = async (fileName, fileType) => {
    //Log("Call params, ", fileName);
    //Log("FileType: ", fileType);
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(
        EndPoints.GET_VIDEO_SIGNATURE,
        {
            "filename": fileName,
            "filetype": fileType
        },
        { headers: { 'Authorization': token } }
    )
        .then((res) => {
            Log('Signature API call Success ', res.data);
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_VIDEO_SIGNATURE)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const createVideo = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_VIDEO(topicId), data,
        {
            headers: {
                'Authorization': token
            },
        })
        .then((res) => {
            //Log(res.data);
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_VIDEO(topicId))
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const createVimeoVideo = async (topicId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_VIMEO_VIDEO(topicId), data,
        {
            headers: {
                'Authorization': token
            },
        })
        .then((res) => {
            //Log(res.data);
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CREATE_VIMEO_VIDEO(topicId))
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const deleteQuizProblemOption = async (optionId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DELETE_QUIZ_PROBLEM_OPTION(optionId), { headers: { 'Authorization': token } })
        .then(res => {
            Log('DELETE_QUIZ_PROBLEM_OPTION response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_QUIZ_PROBLEM_OPTION(optionId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const cloneQuiz = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PM_CLONE_QUIZ(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PM_CLONE_QUIZ response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PM_CLONE_QUIZ(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const cloneAssignment = async (id, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.PM_CLONE_ASSIGNMENT(id), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('PM_CLONE_ASSIGNMENT response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.PM_CLONE_ASSIGNMENT(id))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getCertificationDetails = async (certificationId, attempt, userId, batchCode, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    if (!IsStringEmpty(userToken)) {
        token = userToken;
    };

    let response = await axios.get(EndPoints.GET_CERTIFICATION_DETAILS(certificationId, attempt, userId, batchCode), { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_CERTIFICATION_DETAILS response => ', response);
            const updatedResponse = ParsedCertificationDetailsData(response.data, userToken ? true : false);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CERTIFICATION_DETAILS(certificationId, attempt, userId, batchCode))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const UpdateCertificationDetails = async (batchCode, certificationId, attempt, userId, userToken, data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    if (!IsStringEmpty(userToken)) {
        token = userToken;
    };

    let response = await axios.post(EndPoints.UPDATE_CERTIFICATION_DETAILS(batchCode, certificationId, attempt, userId), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_CERTIFICATION_DETAILS response => ', response);
            // const updatedResponse = ParsedCertificationDetailsData(response.data);
            // response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CERTIFICATION_DETAILS(certificationId, attempt, userId, batchCode))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const GenerateCertificate = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GENERATE_LEARNER_CERTIFICATE, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GENERATE__LEARNER_CERTIFICATE)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}
const DeleteCertificationEnrollment = async (enrollmentId) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.DELETE_CERTIFICATION_ENROLLMENT(enrollmentId),
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.DELETE_CERTIFICATION_ENROLLMENT)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getCertificationDashboardData = async (userId, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    if (!IsStringEmpty(userToken)) {
        token = userToken;
    }

    let response = await axios.get(EndPoints.GET_ACTIVE_CERTIFICATION_DETAILS(userId), { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_ACTIVE_CERTIFICATION_DETAILS response => ', response);
            let updatedResponse;

            if (!IsStringEmpty(userToken)) {
                updatedResponse = parsedAllDashboardCertificationsData(response.data);
            } else {
                updatedResponse = parsedDashboardCertificationsData(response.data);
            }

            response.data = updatedResponse;

            return response;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_ACTIVE_CERTIFICATION_DETAILS(userId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getCertificationRoundResources = async (roundId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CERTIFICATION_ROUND_RESOURCES(roundId), { headers: { 'Authorization': token } })
        .then(response => {
            // Log('GET_CERTIFICATION_ROUND_RESOURCES response => ', response.data);
            const updatedResponse = parsedCertificationResources(response.data);
            response.data = updatedResponse;
            return response;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CERTIFICATION_ROUND_RESOURCES(roundId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const rescheduleCertificationRound = async (userId, data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.RESCHEDULE_CERTIFICATION_ROUND(userId), data, { headers: { 'Authorization': token } })
        .then(res => {
            // Log('RESCHEDULE_CERTIFICATION_ROUND response => ', res);
            return res;
        })
        .catch(error => {
            // Error(error.response);
            return Promise.reject({
                error: ParsedError(error, EndPoints.RESCHEDULE_CERTIFICATION_ROUND(userId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const applyForCertificationReattempt = async (data) => {
    let response = await axios.post(EndPoints.APPLY_FOR_CERTIFICATION_REATTEMPT, data)
        .then((res) => {
            // res.data = res.data.order_id;
            // console.log('Success => ', res.data);
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.APPLY_FOR_CERTIFICATION_REATTEMPT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}


const generateRazorpayOrderId = async (orderData) => {
    let response = await axios.post(EndPoints.GENERATE_RAZORPAY_ORDER_ID, orderData)
        .then((res) => {
            res.data = res.data.order_id;
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GENERATE_RAZORPAY_ORDER_ID)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const submitProjectLinks = async (data, batchCode, userId, certificationCode, roundCode, attempt) => {
    let response = await axios.post(EndPoints.SUBMIT_CERTIFICATION_PROJECT_LINKS(userId, batchCode, certificationCode, roundCode, attempt), data)
        .then((res) => {
            // Log('SUBMIT_CERTIFICATION_PROJECT_LINKS Success:', res.data);
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}


const captureRazorpayPayment = async (paymentData) => {
    let response = await axios.post(EndPoints.CAPTURE_RAZORPAY_PAYMENT, paymentData)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CAPTURE_RAZORPAY_PAYMENT)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const updateLearnerAccomplishments = async (data, id, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    if (!IsStringEmpty(userToken)) {
        token = 'Token ' + userToken;
    }

    let response = await axios.post(EndPoints.LEARNER_HONORS_AND_ACCOMPLISHMENTS(id), data, { headers: { 'Authorization': token } })
        .then((res) => {
            const updatedResponse = ParsedHonorsAndAccomplishments(res.data.honors_and_accomplishments);
            res.data = updatedResponse;
            return res;
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.LEARNER_HONORS_AND_ACCOMPLISHMENTS)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}

const instructorSessionDurationReport = async (instructorObj) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.INSTRUCTOR_SESSION_DURATION_REPORTS, instructorObj, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('GET_ALL_MODULE_TEMPLATES_LIST ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_BATCHMATES_DETAILS)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const rescheduleCertificationExam = async (user_id, certification_code, attempt_number, data, batchCode) => {
    // console.log(data)
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.RESCHEDULE_CERTIFICATION(user_id, certification_code, attempt_number, batchCode), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CLONE PROGRAM_TEMPLATE_DETAILS => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.RESCHEDULE_CERTIFICATION)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const PMRescheduleCertificationExam = async (user_id, certification_code, attempt_number, batchCode, token, data) => {
    // console.log(data)
    // const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.RESCHEDULE_CERTIFICATION(user_id, certification_code, attempt_number, batchCode), data,
        { headers: { 'Authorization': token } })
        .then(response => {
            // Log('CLONE PROGRAM_TEMPLATE_DETAILS => ', response.data);

            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.RESCHEDULE_CERTIFICATION)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getCertificationsList = async (batchCode, token) => {
    const userToken = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let authToken = !IsStringEmpty(token) ? token : userToken;
    let response = await axios.get(EndPoints.GET_CERTIFICATIONS_LIST(batchCode), {
        headers: {
            'Authorization': authToken
        }
    }).then((response) => {
        // Log('GET_CERTIFICATIONS_LIST', response.data);

        const updatedData = !IsObjectEmpty(response.data.certifications)
            ? ParsedCertificationList(response.data.certifications)
            : { instructorName: response.data.instructor_name }
        response.data = updatedData;
        // console.log(response)
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CERTIFICATIONS_LIST, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getCertificationSectionCertificateDetails = async (attemptNumber, certificationCode, batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CERTIFICATION_SECTION_CERTIFICATION_DETAILS(attemptNumber, certificationCode, batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_CERTIFICATION_SECTION_CERTIFICATION_DETAILS', response.data);

        const updatedData = ParsedCertificationSectionCertificateDetails(response.data)
        response.data = updatedData;
        // console.log(response)
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CERTIFICATION_SECTION_CERTIFICATION_DETAILS, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getCertificationSectionCertificateDetailsWithToken = async (attemptNumber, certificationCode, batchCode, token) => {
    // const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CERTIFICATION_SECTION_CERTIFICATION_DETAILS(attemptNumber, certificationCode, batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_CERTIFICATION_SECTION_CERTIFICATION_DETAILS', response.data);

        const updatedData = ParsedCertificationSectionCertificateDetails(response.data)
        response.data = updatedData;
        // console.log(response)
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CERTIFICATION_SECTION_CERTIFICATION_DETAILS, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getCompleteCertificationData = async (batchCode, attemptNumber, certificationCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_COMPLETE_CERTIFICATION_DATA(batchCode, attemptNumber, certificationCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_COMPLETE_CERTIFICATION_DATA', response.data);

        const updatedData = ParsedCompleteCertificationData(response.data)
        response.data = updatedData;
        // console.log(response)
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_COMPLETE_CERTIFICATION_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getCompleteCertificationModulesPageData = async (batchCode, attemptNumber, certificationCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_COMPLETE_CERTIFICATION_MODULES_PAGE_DATA(batchCode, attemptNumber, certificationCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_COMPLETE_CERTIFICATION_DATA', response.data);


        const parsedObj = {
            modulesList: ParsedModulesPageModulesList(response.data),
            currentTopic: ParsedTopicsList([response.data.topics_list.selected_topic]),
            currentTopicDetails: ParsedTopicDetails(response.data.topics_details),
            certification: ParsedCertificationSectionCertificateDetails(response.data.certification_data),
        }
        response.data = parsedObj;

        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_COMPLETE_CERTIFICATION_DATA, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const certificationUpdatePopup = async (enrolmentId = 3682) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CERTIFICATION_UPDATE_POPUP(enrolmentId), { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_UPDATE_POPUP ERROR => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_UPDATE_POPUP)
            });
        })
    return Promise.resolve({
        result: response.data
    });

}

const certificationSecondRoundDetails = async (enrolmentId, certificateCode, roundNumber, attemptNumber) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.CERTIFICATION_SECOND_ROUND_DETAILS(enrolmentId, certificateCode, roundNumber, attemptNumber), { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_SECOND_ROUND_DETAILS ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_SECOND_ROUND_DETAILS)
            });
        })
    return Promise.resolve({
        result: response.data
    });

}

const certificationSaveChanges = async (enrolmentId, data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CERTIFICATION_UPDATE_POPUP(enrolmentId), data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_UPDATE_POPUP ERROR => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_UPDATE_POPUP)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const certificationUpdateDetails = async (enrollmentId, token, data) => {
    // let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CERTIFICATION_UPDATE_DETAILS(enrollmentId), data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_UPDATE_POPUP ERROR => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_UPDATE_POPUP)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const certificationUpdateRoundDetails = async (enrolmentId, certificationCode, roundNumber, attemptNumber, token, data) => {
    let response = await axios.post(EndPoints.CERTIFICATION_UPDATE_ROUND_DETAILS(enrolmentId, certificationCode, roundNumber, attemptNumber), data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_UPDATE_POPUP ERROR => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_UPDATE_POPUP)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const PMcertificationUpdateRoundDetails = async (batchCode, certificationId, attempt, userId, roundNumber, userToken, data) => {
    let response = await axios.post(EndPoints.PM_CERTIFICATION_UPDATE_ROUND_DATA(batchCode, certificationId, attempt, userId, roundNumber), data,
        { headers: { 'Authorization': userToken } }
    ).then((res) => {
        return res;
    }).catch(error => {
        console.log(error);
    })

    return Promise.resolve({
        result: response.data
    })
}

const getReferralData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_REFERRAL_DATA, {
        headers: { 'Authorization': token }
    }).then((response) => {
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_REFERRAL_DATA)
            })
        });
    return Promise.resolve({
        result: response.data
    });
}

const inviteViaEmail = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.INVITE_VIA_EMAIL, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.INVITE_VIA_EMAIL)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const sendInviteReminder = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.SEND_INVITE_REMINDER, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.SEND_INVITE_REMINDER)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getClaimData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_CLAIM_DATA, {
        headers: { 'Authorization': token }
    }).then((response) => {
        return response
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_CLAIM_DATA)
            })
        });
    return Promise.resolve({
        result: response.data
    });
}

const requestRewardClaim = async (data) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.REWARD_CLAIM, data,
        { headers: { 'Authorization': token } })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.REWARD_CLAIM)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getAllJobs = async () => {
    //temporary, we'll move it to .env
    // const token = "41ARPtNpNOWMmESE73EwgZfSMWPR-8R4XxqcFeYGs-C1pMww18M-r2t8Q36xP6k7rircBOl8nmzR5NW9KXqUQ18xNTk1NTg4MDAz"
    var config = {
        method: 'get',
        url: 'https://api.recruitcrm.io/v1/jobs/search?job_status=1&sort_by=createdon',
        headers: {
            'Authorization': `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            const parsedData = ParsedAllJobs(response.data.data)
            response.data = parsedData
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, 'https://api.recruitcrm.io/v1/jobs/search?job_status=1&sort_by=createdon')
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getTotalJobs = async () => {
    let allJobs = []
    let page = 1;
    let next_page_url = true

    while (next_page_url) {
        var config = {
            method: 'get',
            url: 'https://api.recruitcrm.io/v1/jobs',
            params: { page: page, limit: '100', sort_by: 'createdon' },
            headers: {
                'Authorization': `Bearer ${Constants.KEY_RCRM_TOKEN}`
            }
        };
        await axios(config)
            .then(response => {
                const parsedData = ParsedAllJobs(response.data.data)
                allJobs = allJobs.concat(parsedData)
                if (!response.data.next_page_url) {
                    next_page_url = false
                }
                page++
            })
            .catch(error => {
                return Promise.reject({
                    error: ParsedError(error, 'https://api.recruitcrm.io/v1/jobs/search?job_status=1&sort_by=createdon')
                });
            })
    }

    return Promise.resolve({
        result: allJobs
    });
}

const getJobDetails = async (slug) => {
    const config = {
        method: 'GET',
        url: `https://api.recruitcrm.io/v1/jobs/${slug}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, `https://api.recruitcrm.io/v1/jobs/${slug}`)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getProfileCompletionStatus = async (candidateSlug) => {

    let incompleteFieldsList = [];
    const config = {
        method: 'GET',
        url: `https://api.recruitcrm.io/v1/candidates/${candidateSlug}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, `https://api.recruitcrm.io/v1/candidates/${candidateSlug}`)
            });
        })
    const customFields = Object.values(response.data.custom_fields)
    let count = 0
    if (!IsStringEmpty(response.data.first_name))
        count++
    else incompleteFieldsList.push("First Name")

    if (!IsStringEmpty(response.data.email))
        count++
    else incompleteFieldsList.push("Email Id")

    if (!IsStringEmpty(response.data.contact_number))
        count++
    else incompleteFieldsList.push("Contact Number")

    if (!IsObjectEmpty(response.data.resume))
        count++
    else incompleteFieldsList.push("Resume")

    if (!IsStringEmpty(customFields.find((field) => field.field_name === "Highest Degree").value))
        count++
    else incompleteFieldsList.push("Highest Degree")

    if (!IsStringEmpty(customFields.find((field) => field.field_name === "Graduation/Highest Degree Completion Year").value))
        count++
    else incompleteFieldsList.push("Graduation/Highest Degree Completion Year")

    if (!IsStringEmpty(customFields.find((field) => field.field_name === "CGPA/Percentage in Highest Degree").value))
        count++
    else incompleteFieldsList.push("CGPA/Percentage in Highest Degree")


    if (!IsStringEmpty(customFields.find((field) => field.field_name === "XII Percentage").value))
        count++
    else incompleteFieldsList.push("XII Percentage")


    if (!IsStringEmpty(customFields.find((field) => field.field_name === "X Percentage").value))
        count++
    else incompleteFieldsList.push("X Percentage")


    if (!IsStringEmpty(response.data.city))
        count++
    else incompleteFieldsList.push("City")


    if (!IsStringEmpty(response.data.linkedin))
        count++
    else incompleteFieldsList.push("LinkedIn Handle")


    if (!IsStringEmpty(response.data.github))
        count++
    else incompleteFieldsList.push("Github Handle")


    // if(!IsStringEmpty(response.data.current_organization))
    // count++
    if (!IsStringEmpty(response.data.notice_period))
        count++
    else incompleteFieldsList.push("Notice Period")


    if (!IsStringEmpty(response.data.relevant_experience) || response.data.relevant_experience === null)
        count++
    else incompleteFieldsList.push("Relevant Experience")



    const profileCompletionPercentage = Math.round(count / 14 * 100)
    console.log('incompleteFieldsList', incompleteFieldsList)

    return Promise.resolve({
        result: profileCompletionPercentage,
        result2: incompleteFieldsList
    });
}

const applyToJob = async (candidateSlug, jobSlug, userId) => {
    const config = {
        method: 'POST',
        url: `https://api.recruitcrm.io/v1/candidates/${candidateSlug}/apply`,
        params: { job_slug: jobSlug },
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            if (response.data.status.label === "Applied") {
                const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
                axios.post(EndPoints.UPDATE_JOB_STATUS(userId, jobSlug), {}, { headers: { 'Authorization': token } })
                    .then(res => {
                        return res;
                    })
                    .catch(error => {
                        return Promise.reject({
                            error: ParsedError(error, EndPoints.UPDATE_JOB_STATUS(userId, jobSlug))
                        });
                    })
            }
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, `https://api.recruitcrm.io/v1/candidates/${candidateSlug}/apply`)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getStageHistoryOfCandidateForJob = async (candidateSlug, jobSlug) => {
    const config = {
        method: 'GET',
        url: `https://api.recruitcrm.io/v1/jobs/${jobSlug}/stage-history/${candidateSlug}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, `https://api.recruitcrm.io/v1/jobs/${jobSlug}/stage-history/${candidateSlug}`)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getAppliedJobsByCandidate = async (userId) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_JOBS_APPLIED_BY_CANDIDATE(userId), { headers: { 'Authorization': token } })
        .then(res => {
            return res;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.EndPoints.GET_JOBS_APPLIED_BY_CANDIDATE(userId))
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const getCompanyBySlug = async (companySlug) => {
    const config = {
        method: 'GET',
        url: `https://api.recruitcrm.io/v1/companies/${companySlug}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            const parsedData = ParsedCompanyData(response.data)
            response.data = parsedData
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, `https://api.recruitcrm.io/v1/companies/${companySlug}`)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getStageHistoryOfAllJobs = async (candidateSlug) => {
    const config = {
        method: 'get',
        url: `https://api.recruitcrm.io/v1/candidates/${candidateSlug}/hiring-stages`,
        headers: {
            'Authorization': `Bearer ${Constants.KEY_RCRM_TOKEN}`
        }
    };
    let response = await axios(config)
        .then(response => {
            const parsedData = ParsedStageHistoryOfAllJobs(response.data)
            response.data = parsedData
            return response;
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, `https://api.recruitcrm.io/v1/candidates/${candidateSlug}/hiring-stages`)
            });
        })

    return Promise.resolve({
        result: response.data
    });
}

const getMissedSessionReport = async (batchCode, duration, consecutiveDays) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let data = {
        batch_code: batchCode,
        duration: duration,
        consecutive_days: consecutiveDays
    }
    let response = await axios.post(EndPoints.GET_MISSING_SESSION_DATA, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedMissedSessionsResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}

const GetStudentJobsReport = async (batchCode) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_STUDENT_JOBS_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        const updatedResponse = ParsedJobsReportResponse(response.data);
        response.data = updatedResponse;
        return response;
    }).catch(error => {
        return Promise.reject({
            error: ParsedError(error, EndPoints.GET_STUDENT_JOBS_DATA)
        })
    })
    return Promise.resolve({
        result: response.data
    })
}

const getMyRewards = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    var config = {
        method: 'get',
        url: EndPoints.GET_MY_REWARDS(batchCode),
        headers: {
            'Authorization': token
        }
    }
    let response = await axios(config)
        .then(response => {
            const parsedData = ParsedMyRewardsData(response.data.all_rewards)
            response.data = parsedData
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_MY_REWARDS(batchCode))
            })
        })

    return Promise.resolve({
        result: response.data
    });
}

const claimReward = async (userId, badgeStatus, rewardStatus) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    const data = JSON.stringify({ badge_status: badgeStatus, reward_status: rewardStatus })
    var config = {
        method: 'post',
        url: EndPoints.CLAIM_REWARD(userId),
        headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
        },
        data: data
    }
    let response = await axios(config)
        .then(response => {
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.CLAIM_REWARD(userId))
            })
        })

    return Promise.resolve({
        result: response.data
    });
}

const getEditRewardsData = async (batchCode) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    var config = {
        method: 'get',
        url: EndPoints.GET_EDIT_REWARDS_DATA(batchCode),
        headers: {
            'Authorization': token
        }
    };
    let response = await axios(config)
        .then(response => {
            const parsedData = ParsedEditRewardsData(response.data.data)
            response.data = parsedData
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_EDIT_REWARDS_DATA(batchCode))
            })
        })

    return Promise.resolve({
        result: response.data
    });
}

const updateRewardsData = async (batchCode, gamificationData) => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    var data = JSON.stringify({ 'gamification_data': gamificationData });

    var config = {
        method: 'post',
        url: EndPoints.UPDATE_REWARDS_DATA(batchCode),
        headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
        },
        data: data
    };
    let response = await axios(config)
        .then(response => {
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.UPDATE_REWARDS_DATA(batchCode))
            })
        })

    return Promise.resolve({
        result: response.data
    });
}


const GetInstructorPaymentReport = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GET_INSTRUCTOR_SESSION_DATA, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedInstructorPaymentReportResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}

const GetModuleCostReport = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GET_MODULE_COST_REPORT, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedModuleCostResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}

const GetLiveSessionDurationReport = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GET_LIVE_SESSION_DURATION_REPORT, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedInstructorPaymentReportResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}
const GetEmailReport = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GET_EMAIL_REPORT, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedEmailReportResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}
const GetAttendanceDashboardReport = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GET_ATTENDANCE_DASHBOARD_REPORT, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedAttendanceDashboardReportResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}
const getInstructorDashboardReport = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.INSTRUCTOR_DASHBOARD_REPORT, data, { headers: { 'Authorization': token } })
        .then(response => {
            const updatedResponse = ParsedInstructoreDashboardReportResponse(response.data);
            response.data = updatedResponse;
            return response
        })
        .catch(error => {
            return Promise.reject({
                error: error
            })
        })
    return Promise.resolve({
        result: response.data
    })
}
const GetActiveLearnerForLast30Days = async () => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_ACTIVE_LEARNER_FOR_LAST_30_DAYS, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        const parsedResponse = ParsedActiveFor30Days(response.data)
        return parsedResponse
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}

const getBatchwiseCertificationDetails = async (batchCode) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_CERTIFICATION_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        const parsedResponse = ParsedBatchwiseCertificationData(response.data)
        return parsedResponse;
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}

const getBatchwiseActiveStudentDetails = async () => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_ACTIVE_STUDENTS_DATA, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        const parsedResponse = ParsedBatchwiseActiveStudentData(response.data)
        return parsedResponse;
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}

const UpdateGamificationData = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.UPDATE_GAMIFICATION_DATA, data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        console.log(response.data)
        const parsedResponse = response.data
        return parsedResponse;
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}

const getBatchwiseCertificationPassStudentDetails = async (batchCode, certificateCode, attemptNumber) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_CERTIFICATION_PASS_STUDENT_DATA(batchCode, certificateCode, attemptNumber), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        const parsedResponse = ParsedBatchwiseCertificationPassStudentData(response.data)
        return parsedResponse;
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}

const getActiveStudentsDetails = async (batchCode) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_ACTIVE_STUDENT_DATA(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        const parsedResponse = ParsedActiveStudentData(response.data)
        return parsedResponse;
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}


const certificationUpdateLinkForAll = async (data, roundCode, certificationCode) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CERTIFICATION_UPDATE_LINK_FOR_ALL(roundCode, certificationCode), data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_UPDATE_LINK_FOR_ALL ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_UPDATE_LINK_FOR_ALL)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}
const sendNotifications = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.post(EndPoints.CREATE_NOTIFICATIONS, data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            return Promise.reject({
                // error: ParsedError(error, EndPoints.CERTIFICATION_UPDATE_LINK_FOR_ALL)
                error: {
                    status: error.response.status,
                    message: error.response.data.message,
                    errorListEmail: error.response.data.unregistered_emails,
                }
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const certificationSendReport = async (data, userToken) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    if (!IsStringEmpty(userToken)) {
        token = userToken
    }

    let response = await axios.post(EndPoints.CERTIFICATION_SEND_REPORT, data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_SEND_REPORT ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_SEND_REPORT)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}
const certficationGeneration = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GENERATE_CERTIFICATE, data, { headers: { 'Authorization': token } })
        .then((res) => {
            return res;
        })
        .catch(error => {
            Log('CERTIFICATION_SEND_REPORT ERROR=> ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.CERTIFICATION_SEND_REPORT)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}

const deleteSessionRecording = async (liveSessionId, data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.DELETE_SESSION_RECORDING(liveSessionId), data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        return response
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}

const getCompanyByJobSlug = async (jobSlug) => {
    const jobDetails = await getJobDetails(jobSlug)
    const companyDetails = await getCompanyBySlug(jobDetails.result.company_slug)
    const companyNameAndJobCreatedDate = {
        companyName: companyDetails.result.companyName,
        dateOfCreation: jobDetails.result.created_on
    }
    return companyNameAndJobCreatedDate
}

const getStudentsEnrollmentList = async (batch_code, certification_code) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.STUDENTS_LIST_PAGE(batch_code, certification_code), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        // console.log("Resource API Response ", response.data[certification_code])
        return response.data[certification_code];

    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}

const companyWisePlacementsData = async (allJobs) => {
    let totalCandidates = []
    let totalUniqueJobApplicants = new Set()

    for (let job of allJobs) {
        const config = {
            method: 'GET',
            url: `https://api.recruitcrm.io/v1/jobs/${job.slug}/assigned-candidates`,
            params: { limit: '100' },
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Constants.KEY_RCRM_TOKEN}`
            }
        };
        await axios(config)
            .then(async (response) => {

                const appliedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Applied')?.length
                const assignedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Assigned')?.length
                const shortlistedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Shortlisted')?.length
                const codingRoundsCandidates = response.data.data.filter(candidate => candidate.status.label === 'Coding Rounds')?.length
                const interviewRoundsCandidates = response.data.data.filter(candidate => candidate.status.label === 'Interview Rounds')?.length
                const placedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Placed')?.length
                const rejectedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Rejected')?.length
                const codingRejectedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Coding Rejected')?.length
                const interviewRejectedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Interview Rejected')?.length
                const certificationRejectedCandidates = response.data.data.filter(candidate => candidate.status.label === 'Certification Required')?.length

                const totalCandidatesApplied = appliedCandidates + assignedCandidates + shortlistedCandidates + codingRoundsCandidates + interviewRoundsCandidates + placedCandidates + rejectedCandidates + codingRejectedCandidates + interviewRejectedCandidates + certificationRejectedCandidates

                response.data.data.forEach(candidate => {
                    totalUniqueJobApplicants.add(candidate.candidate.slug)
                })

                const totalCandidatesForJob = {
                    totalCandidatesApplied,
                    appliedCandidates,
                    assignedCandidates,
                    shortlistedCandidates,
                    codingRoundsCandidates,
                    interviewRoundsCandidates,
                    placedCandidates,
                    rejectedCandidates,
                    codingRejectedCandidates,
                    interviewRejectedCandidates,
                    certificationRejectedCandidates
                }

                const companyNameAndJobCreatedDate = await getCompanyByJobSlug(job.slug)
                const jobTitleWithoutCompanyName = job.title.split('|')[0]

                totalCandidates.push(
                    {
                        jobSlug: job.slug,
                        jobTitle: jobTitleWithoutCompanyName,
                        compnayName: companyNameAndJobCreatedDate.companyName,
                        dateOfCreation: companyNameAndJobCreatedDate.dateOfCreation,
                        candidates: totalCandidatesForJob
                    }
                )

            })
            .catch(error => {
                return Promise.reject({
                    error: ParsedError(error, `https://api.recruitcrm.io/v1/jobs/${job.slug}/assigned-candidates`)
                });
            })
    }

    return Promise.resolve({
        result: {
            placementsData: totalCandidates,
            totalUniqueJobApplicants: totalUniqueJobApplicants.size
        }
    })
}


const getBatchwiseAttendanceReport = async (batchCode, moduleName, isFull) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.BATCHWISE_ATTENDANCE_REPORT(batchCode, moduleName, isFull), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        let parsedData = ParsedBatchwiseAttendance(response.data)
        return parsedData
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}

const discourseSSOLogin = async (params) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.DISCOURSE_SSO(params), { headers: { 'Authorization': token } })
        .then((res) => {
            console.log("Discourse SSO API Response => ", res.data)
            return res;
        })
        .catch(error => {
            Log('Discourse SSO API ERROR => ', error);

            return Promise.reject({
                error: ParsedError(error, EndPoints.DISCOURSE_SSO)
            });
        })
    return Promise.resolve({
        result: response.data
    });
}


const getLearnerJRSValue = async (batchCode) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_LEARNER_JRS(batchCode), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        let updatedResponse = response.data;
        return updatedResponse;
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}


const generateMettlJSONObject = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.GENERATE_METTL_JSON_OBJECT, data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        // console.log("Response => ", response)
        return response
    }).catch(error => {
        console.log("Error => ", error)
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}


const getLearnersCertificationDetailsList = async (certificationType, scheduledDate) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.GET_LEARNERS_CERTIFICATION_DETAILS_LIST(certificationType, scheduledDate), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        let parsedData = ParsedLearnerCertificationsListData(response.data.users)
        return parsedData
    }).catch(error => {
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })

}


const updateLearnerCertificationCompleteData = async (batchCode, certificationId, attemptNumber, userId, data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.UPDATE_LEARNER_COMPLETE_CERTIFICATION_DATA(batchCode, certificationId, attemptNumber, userId), data, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        // console.log("updateLearnerCertificationCompleteData Response => ", response)
        return response
    }).catch(error => {
        console.log("updateLearnerCertificationCompleteData Error => ", error)
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}


const updateCBCertificationRound1Result = async (quizId) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.post(EndPoints.UPDATE_CB_ROUND1_CERTIFICATION_RESULT(quizId), {}, {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        // console.log("updateCBCertificationRound1Result Response => ", response)
        return response
    }).catch(error => {
        console.log("updateCBCertificationRound1Result Error => ", error)
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}


const updateCBCertificationOverallResult = async (scheduledDate) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    let response = await axios.get(EndPoints.UPDATE_CB_OVERALL_CERTIFICATION_RESULT(scheduledDate), {
        headers: {
            'Authorization': token
        }
    }).then(response => {
        // console.log("updateCBCertificationOverallResult Response => ", response)
        return response
    }).catch(error => {
        console.log("updateCBCertificationOverallResult Error => ", error)
        return Promise.reject({
            error: error
        })
    })
    return Promise.resolve({
        result: response
    })
}

const getUserBatchDetailsForMDCertificate = async (username, batchCode) => {

    let response = await axios.get(EndPoints.GET_LEARNER_BATCH_DETAILS_FOR_MD_CERTIFICATE(username, batchCode))
        .then(response => {
            // console.log('getUserBatchDetailsForMDCertificate Response => ', response);
            const userData = response.data[0];

            const updatedData = {
                learnerFullName: userData.full_name,
                userId: userData.user_id,
                courseName: userData.program_name,
                startDate: parseDate(userData.start_date),
                endDate: parseDate(userData.end_date),
                batchCode: batchCode,
                instructorName: userData.instructor_name
            }
            response.data = updatedData;
            return response;
        })
        .catch(error => {
            // console.log('[Catch Error]  => ', error);
            return Promise.reject({
                error: error.response.data
            });
        })

    return Promise.resolve({
        result: response.data
    });
}


const getProgramDates = async () => {
    let response = await axios.get(EndPoints.GET_PROGRAM_DATES)
        .then
        ((res) => {
            // console.log('response => ', res)
            return ParsedProgramDates(res.data)
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_PROGRAM_DATES)
            })
        })

    return Promise.resolve({
        result: response
    })
}

const getCoursesList = async () => {
    let response = await axios.get(EndPoints.GET_COURSES_LIST)
        .then
        ((res) => {
            // console.log('response => ', res)
            return ParsedCoursesList(res.data)
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_COURSES_LIST)
            })
        })

    return Promise.resolve({
        result: response
    })
}

const getCourseDetails = async (courseId) => {
    let response = await axios.get(EndPoints.GET_COURSES_DETAILS(courseId))
        .then
        ((res) => {
            // console.log('response => ', res)
            return ParsedCourseDetails(res.data.course)
            // return res.data
        })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_COURSES_DETAILS(courseId))
            })
        })

    return Promise.resolve({
        result: response
    })
}

const getWhatsappTemplates = async () => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    const response = await axios.get(EndPoints.GET_WHATSAPP_TEMPLATES, { headers: { "Authorization": token } })
        .then(response => {
            const parsedData = ParsedWATemplatesList(response.data.templates);
            return response.data = parsedData;
        })
        .catch(error => {
            // console.log("Received Error => ", error)
            return Promise.reject({
                error: error
            })
        })

    return Promise.resolve({
        result: response
    })
}

const getTemplateDetails = async (templateId) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    const response = await axios.get(EndPoints.GET_WHATSAPP_TEMPLATE_DETAILS(templateId), { headers: { "Authorization": token } })
        .then(response => {
            const template = response.data.template;
            return response.data = ParsedWhatsappTemplate(template)
        })
        .catch(error => {
            // console.log("Error => ", error);
            return Promise.reject({
                error: error
            })
        })

    return Promise.resolve({
        result: response
    })
}

const sendWhatsappNotifications = async (templateId, data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    const response = await axios.post(EndPoints.SEND_WHATSAPP_NOTIFICATIONS(templateId), data, { headers: { "Authorization": token } })
        .then(response => {
            // console.log('SEND_WHATSAPP_NOTIFICATIONS response => ', response.data)
            return response;
        })
        .catch(error => {
            // console.log('error => ', error);
            return Promise.reject({
                error: {
                    status: error.response.status,
                    message: error.response.data.message,
                    errorNames: error.response.data.failure_names,
                }
            });
        })

    return Promise.resolve({
        result: response
    });
}

const learnerSelfCohortEnroll = async (data) => {
    let token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    const response = await axios.post(EndPoints.LEARNER_SELF_COHORT_ENROLL, data, { headers: { "Authorization": token } })
        .then(response => {
            // console.log('LEARNER_SELF_COHORT_ENROLL response => ', response.data)
            return response;
        })
        .catch(error => {
            console.log('error => ', error);
            return Promise.reject({
                error: error
            });
        })

    return Promise.resolve({
        result: response
    });
}

const getRecommendedCourses = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_USER_COURSE_RECOMMENDATIONS, {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Log('GET_USER_COURSE_RECOMMENDATIONS => ', response.data);
        const parsedData = getParsedRecommendedCourses(response.data.recommendation_list);
        response.data = parsedData;

        return response
    })
        .catch((error) => {
            // Log('GET_USER_COURSE_RECOMMENDATIONS error=> ', error);
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_USER_COURSE_RECOMMENDATIONS, APICodes.COMMON_DATA)
            })
        });

    return Promise.resolve({
        result: response.data
    });
}

const getMDCourseListingData = async () => {
    let response = await axios.get(EndPoints.GET_MD_COURSE_LISTING_DATA, null, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
            // console.log('GET_MD_COURSE_LISTING_DATA response => ', res)
            return ParsedMDCourseListingData(res.data)
        })
        .catch((error) => {
            console.log("[GET_MD_COURSE_LISTING_DATA Function Error: ", ParsedError(error))
            return Promise.reject({ error: ParsedError(error) })
        })

    return Promise.resolve({ result: response })
}

const getCoursesData = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.GET_COURSES_DATA, {
        headers: {
            'Authorization': token
        }
    }).then((response) => {
        // Parse the CSV-like data from backend
        const rawData = response.data;
        const parsedData = [];

        if (typeof rawData === 'string') {
            // Split by lines and parse CSV format
            const lines = rawData.trim().split('\n');
            const headers = lines[0].split(',');

            for (let i = 1; i < lines.length; i++) {
                const values = lines[i].split(',');
                const courseObj = {};

                headers.forEach((header, index) => {
                    courseObj[header.trim()] = values[index] ? values[index].trim() : '';
                });

                parsedData.push(courseObj);
            }
        } else if (Array.isArray(rawData)) {
            // If data is already parsed as array
            parsedData.push(...rawData);
        }

        response.data = parsedData;
        return response;
    })
        .catch((error) => {
            return Promise.reject({
                error: ParsedError(error, EndPoints.GET_COURSES_DATA)
            });
        });

    return Promise.resolve({
        result: response.data
    });
}


// Function to get upcoming batches
const getUpcomingBatches = async () => {
    const token = (GetFromLocalStorage(Constants.KEY_TOKEN) !== null && GetFromLocalStorage(Constants.KEY_TOKEN) !== '') ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';

    try {
        let response = await axios.get(EndPoints.GET_UPCOMING_BATCHES, {
            headers: {
                'Authorization': token
            }
        });

        console.log('Upcoming batches API response:', response.data);

        return Promise.resolve({
            result: response.data
        });
    } catch (error) {
        console.error('Error in getUpcomingBatches:', error);

        // Return dummy data as fallback
        const DUMMY_UPCOMING_BATCHES = [
            {
                program_name: "Full Stack Web Development",
                batch_code: "FSWD-2025-08",
                start_date: "2025-08-15",
                end_date: "2026-02-15",
                enrolled_students: 25,
                status: "Upcoming"
            },
            {
                program_name: "Data Science & Machine Learning",
                batch_code: "DSML-2025-07",
                start_date: "2025-07-25",
                end_date: "2026-01-25",
                enrolled_students: 30,
                status: "Upcoming"
            },
            {
                program_name: "Python Development",
                batch_code: "PYD-2025-09",
                start_date: "2025-09-05",
                end_date: "2026-03-05",
                enrolled_students: 20,
                status: "Upcoming"
            }
        ];

        return Promise.resolve({
            result: {
                batches: DUMMY_UPCOMING_BATCHES
            }
        });
    }
};

const getMobileBatchCodes = async () => {
    const userToken = GetFromLocalStorage(Constants.KEY_TOKEN) ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MOBILE_GET_BATCH_CODES, {
        headers: { 'Authorization': userToken }
    }).catch(error => Promise.reject({ error: ParsedError(error, EndPoints.MOBILE_GET_BATCH_CODES) }));
    return Promise.resolve({ result: response.data });
};

const getAppInstalledLearners = async (batchCode) => {
    const userToken = GetFromLocalStorage(Constants.KEY_TOKEN) ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    let response = await axios.get(EndPoints.MOBILE_APP_INSTALLED_LEARNERS(batchCode), {
        headers: { 'Authorization': userToken }
    }).catch(error => Promise.reject({ error: ParsedError(error, EndPoints.MOBILE_APP_INSTALLED_LEARNERS(batchCode)) }));
    return Promise.resolve({ result: response.data });
};

const sendMobilePushNotificationCSV = async (csvFile, title, message, ctaScreen = null, ctaParams = null) => {
    const userToken = GetFromLocalStorage(Constants.KEY_TOKEN) ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    const formData = new FormData();
    formData.append('file', csvFile);
    formData.append('title', title);
    formData.append('message', message);
    if (ctaScreen) formData.append('cta_screen', ctaScreen);
    if (ctaParams) formData.append('cta_params', JSON.stringify(ctaParams));
    let response = await axios.post(EndPoints.MOBILE_SEND_PUSH_NOTIFICATION_CSV, formData, {
        headers: { 'Authorization': userToken }
    }).catch(error => Promise.reject({ error: ParsedError(error, EndPoints.MOBILE_SEND_PUSH_NOTIFICATION_CSV) }));
    return Promise.resolve({ result: response.data });
};

const sendMobilePushNotification = async (batchCode, title, message, ctaScreen = null, ctaParams = null) => {
    const userToken = GetFromLocalStorage(Constants.KEY_TOKEN) ? 'Token ' + GetFromLocalStorage(Constants.KEY_TOKEN) : '';
    const body = { batch_code: batchCode, title, message };
    if (ctaScreen) {
        body.cta_screen = ctaScreen;
        if (ctaParams) body.cta_params = ctaParams;
    }
    let response = await axios.post(EndPoints.MOBILE_SEND_PUSH_NOTIFICATION, body, {
        headers: { 'Authorization': userToken }
    }).catch(error => Promise.reject({ error: ParsedError(error, EndPoints.MOBILE_SEND_PUSH_NOTIFICATION) }));
    return Promise.resolve({ result: response.data });
};

const ResourceAPIController = {
    getUpcomingBatches, userPostLoginData, userPostLoginDataInstructor, userPostLoginDataInstructorForModule, getContinueLearningData, getUpcomingCompletedModulesData, getModuleDetails, getModuleTopicsList, getModuleTopicsDetails, getModuleQuizTopicsDetails, getModuleAssignmentTopicsDetails, getFeedbackData, getInstructorsList, getInstructorDetails, submitQuizResponses, getQuizResult, createWorkExperience, updateWorkExperience,

    getEditProfileData, updateLearnerProfile, updateLearnerPlacementAssistanceStatus, getBatchmatesList, getInstructorDashboardReport, getGroupData, rescheduleCertificationExam, getCompleteCertificationData,
    updatePinnedVideo, contactUs, getDropdownNotifications, getPublicProfileData, createEducationSummaryItem, updateEducationSummaryItem, getAllLearnerSubmissions, submitAssignmentProblem, getAssignmentProblemResult, getCertificationsList,
    submitDailyFeedback, getOverallProgramPerformanceData, getOverallProgramAttendanceData, getOverallProgramGradesData, getJRSData, CalculateJRSData, CalculateWholeJRSData, getOverallProgramSubmissionsData, getModuleCompleteTopicDetails, getModuleCompleteQuizDetails, getCertificationSectionCertificateDetails,
    getModuleCompleteAssignmentDetails, getLastSessionFeedbackData, getCurriculumTopicsListData, getInstructorProgramListData, getCurriculumTopicDetails, getCurriculumQuizDetails, getCurriculumAssignmentDetails, editQuizDetails, addNewQuizQuestion,
    updateQuizQuestion, editAssignmentDetails, addNewAssignmentProblem, updateAssignmentProblem, getModulePlannerData, getCurriculumCompleteQuizDetails, getCurriculumCompleteAssignmentDetails, getCurriculumCompleteTopicDetails, getCompleteCertificationModulesPageData,
    createNewAssignment, createNewQuiz, createNewTopic, getInstructorAllModulesList, plannerPageMarkDayOff, updateTopicData, updateSessionPlanData, deleteSubtopic, getEvaluationPageDetails, getQuizSubmissionMetaData, getQuizStudentSubmissionsList, getAssignmentSubmissionMetaData,
    getAssignmentStudentSubmissionsList, getAssignmentStudentSubmissionsData, assignStudentGrades, startInstructorLiveSession, endInstructorLiveSession, getLearnerLiveSessionData, getInstructorDailyFeedbackReport, getInstructorDailyFeedbackReportForTopic,
    getDailyFeedbackStudentsListForTopic, getStudentDailyFeedbackResponse, getInstructorWeeklyFeedbackReport, getFeedbackReportForParticularWeek, getStudentWeeklyFeedbackResponse, getInstructorOverallReport, getInstructorClassGradesReport, getInstructorAttendanceReport,
    getInstructorStudentAttendanceReport, getLearnerQuizSubmissionResponses, markStudentAttendance, getPMHomepageOngoingModulesData, getPMLearnerOverallStats, getPMAllLeanersList, getPMLeanersSearchResults, getPMProgramsList, addNewLearnerPM, autoEnrollLearner, getUpcomingCertificationDetails,
    getPMInstructorOverallStats, getPMAllInstructorsList, getPMSearchProgram, getPMInstructorSearchResults, getPMProgramsListInstructor, addNewInstructorPM, getPMProgramModulesList, downloadLearnerTemplate, downloadInstructorTemplate, bulkUploadLearner, instructorSessionDurationReport,
    bulkUploadInstructor, getUserAccountData, saveUserAccountSettings, getAllProgramsPageData, getPaginatedProgramsListData, getProgramListData, getProgramOverviewData, getCurriculumOverviewData, getInstructorsData, deleteCurriculumTopic, getPMInstructorPerformanceData, getPMInstructorModulePerformanceData,
    getModulePerformanceData, getAllModulesListForProgram, getEditModuleList, deleteModule, getAllProgramTemplatesList, getAllModuleTemplatesList, certificationViewReports, UpdateNotAttemptedStatus, getLiveSessionScheduleData, getProgramTemplateDetails, cloneProgramFromTemplate, getModuleTemplateDetails, cloneModuleFromTemplate,
    unenrollLearnerFromProgram, getProgramPerformanceAttendanceData, getProgramPerformanceClassGradesData, getEditProgramFormDetails, editProgramFormDetails, getEditModuleFormDetails, editModuleFormDetails, deleteQuizSubmissions, deleteAssignmentSubmissions, getPMCurriculumTopicsListData,
    getPMCurriculumCompleteTopicDetails, markLearnerAttendance, createNewModule, certificationEnrollment, copyLiveSessionDetail, editLiveSessionDetail, getPMCertificationList, getNewModuleDetails, getInstructorDailyFeedbackReportPM, getProgramManagersList, createNewProgram, editAssignmentSubmission, deleteAssignment, deleteQuiz, deleteQuizProblem, deleteGradingCriteria, addResourcesPDF, addResourcesSlides, addResourcesOtherFile,
    addEmbedResourceLink, getVideoUploadSignature, createVideo, createVimeoVideo, deleteQuizProblemOption, cloneQuiz, cloneAssignment, getCertificationDetails, getCertificationDashboardData, getCertificationRoundResources, rescheduleCertificationRound, applyForCertificationReattempt,
    generateRazorpayOrderId, submitProjectLinks, captureRazorpayPayment, getPublicProfileDataNew, updateLearnerAccomplishments, getReferralData, inviteViaEmail, sendInviteReminder, getClaimData, requestRewardClaim, getAllJobs, getJobDetails, getProfileCompletionStatus, applyToJob,
    getStageHistoryOfCandidateForJob, getAppliedJobsByCandidate, getCompanyBySlug, getStageHistoryOfAllJobs, getMissedSessionReport, GetStudentJobsReport, getMyRewards, claimReward, getEditRewardsData, GetInstructorPaymentReport, GetModuleCostReport, GetActiveLearnerForLast30Days, deleteSessionRecording,
    updateRewardsData, certificationUpdatePopup, certificationSecondRoundDetails, certificationSaveChanges, getPMFilteredPaginatedData, getCertificationSectionCertificateDetailsWithToken, certificationUpdateDetails, certificationUpdateRoundDetails, PMRescheduleCertificationExam, UpdateCertificationDetails, GenerateCertificate, DeleteCertificationEnrollment, PMcertificationUpdateRoundDetails, getBatchwiseCertificationDetails, getBatchwiseActiveStudentDetails, UpdateGamificationData, GetLiveSessionDurationReport, certificationUpdateLinkForAll, certificationSendReport, certficationGeneration, getTotalJobs, companyWisePlacementsData, GetAttendanceDashboardReport, getBatchwiseAttendanceReport, getStudentsEnrollmentList, getBatchwiseCertificationPassStudentDetails, getActiveStudentsDetails, discourseSSOLogin, addRCRMSlugInBulk, deleteEducation, deleteWorkExperience, deleteAccomplishments, GetEmailReport, sendNotifications, rescheduleCertificationDate, getLearnerJRSValue, getInstructorDailyFeedbackReportOnPageLoadNew, getNewFeedbackData, getInstructorDailyFeedbackReportOnPageLoad, getPMDailyFeedbackReportOnPageLoad, getInstructorOverallFeedbackReport, getInstructorOverallFeedbackReportNew, getPMOverallFeedbackReport, updateStudentBatchStatus, generateMettlJSONObject, getProgramManagerData, getPMHomepageStats, getLearnersCertificationDetailsList, updateLearnerCertificationCompleteData, updateCBCertificationRound1Result, updateCBCertificationOverallResult, getUserBatchDetailsForMDCertificate, getProgramDates, getCoursesList, getCourseDetails, getWhatsappTemplates, getTemplateDetails, sendWhatsappNotifications, getAutoEnrollUserLearningData, learnerSelfCohortEnroll, getRecommendedCourses, getMDCourseListingData, getCoursesData,
    getMobileBatchCodes, getAppInstalledLearners, sendMobilePushNotification, sendMobilePushNotificationCSV,
    createSync, getSyncList, updateSyncSeats, getMdInstructors, getSyncSpeaker, setSyncSpeaker
};

export default ResourceAPIController;